/* Magna e Spigni — base.js
   Fase 2: Web Components dei comportamenti globali. Vanilla, senza dipendenze.
   - <mes-drawer>: pannello a scorrimento con aria-modal, focus trap, chiusura con Esc,
     tocco fuori e tasto indietro (history).
   - <mes-header>: fisso, si nasconde scorrendo in giù e ricompare in su.
   - <mes-annunci>: messaggi a rotazione, pausa a tocco.
   - select[data-invia-al-cambio]: i selettori lingua/paese inviano il form al cambio.
   - scheda prodotto minima: sincronizza i radio taglia con la select delle varianti. */
document.addEventListener('touchstart', function () {}, { passive: true });   // senza un ascoltatore touch, iOS non applica :active (risposta al tocco, 24/09/2026).

(() => {
  'use strict';

  /* ---------------------------------------------------------------- utilità condivise */
  const MES = window.MES = window.MES || {};
  /* stessa regola dello snippet prezzo.liquid: il simbolo dell'euro in uno span con un filo di margine (25/09/2026) */
  MES.prezzoHtml = (testo) => String(testo || '').replace(/[<>&]/g, '').replace('€', '<span class="cifre__valuta">€</span>');
  MES.fmt = (cent) => {
    const money = (window.Shopify && window.Shopify.currency && window.Shopify.currency.active) || 'EUR';
    try { return new Intl.NumberFormat(document.documentElement.lang || 'it', { style: 'currency', currency: money }).format(cent / 100); }
    catch (e) { return (cent / 100).toFixed(2) + ' €'; }
  };
  /* Soglia (snippet soglia-spedizione): due stati, senza cifre. Conta solo gli articoli da spedire (la gift
     card no, regola CLAUDE.md 6): nascosto quando non c'è niente da spedire. */
  /* totale che conta per la soglia di spedizione: righe da spedire, netto sconti di riga (final_line_price) e di ordine (codici e automatici
     sul totale, che cart.js tiene in cart_level_discount_applications e Shopify ripartisce in proporzione). Stessa formula del Liquid
     (snippet totale-spedibile): il 21/10/2026 con 2 × Hot Lap e WINBACK-15 il netto era 59,33 € e al checkout la spedizione 5,90 € */
  MES.spedibile = (carrello) => {
    const righe = (carrello && carrello.items) || [];
    const sp = righe.filter((i) => i.requires_shipping).reduce((acc, i) => ({ totale: acc.totale + i.final_line_price, n: acc.n + i.quantity }), { totale: 0, n: 0 });
    const scontoOrdine = ((carrello && carrello.cart_level_discount_applications) || []).reduce((a, d) => a + (Number(d.total_allocated_amount) || 0), 0);
    const base = Number(carrello && carrello.items_subtotal_price) || 0;
    if (scontoOrdine > 0 && base > 0 && sp.totale > 0) sp.totale = Math.max(0, sp.totale - Math.floor(scontoOrdine * sp.totale / base));
    return sp;
  };
  MES.importo = (cent) => (Math.max(0, cent) / 100).toFixed(2).replace('.', ',').replace(/,00$/, '');
  /* importo mancante nella valuta del carrello (22/10/2026): in euro come prima ("9,67 €"), nelle altre valute con il codice ("98,50 CHF",
     "1.050 SEK"); i centesimi a zero non si scrivono */
  MES.importoValuta = (cent, valuta) => {
    const c = Math.max(0, Math.round(cent));
    if (!valuta || valuta === 'EUR') return MES.importo(c) + ' €';
    const intero = c % 100 === 0;
    try { return new Intl.NumberFormat('it-IT', { style: 'currency', currency: valuta, currencyDisplay: 'code', minimumFractionDigits: intero ? 0 : 2, maximumFractionDigits: intero ? 0 : 2 }).format(c / 100).replace(/\s+/g, ' '); }
    catch (e) { return MES.importo(c) + ' ' + valuta; }
  };
  /* soglia in centesimi della valuta del carrello (22/10/2026): con l'euro la scrive il Liquid (data-valore-soglia); con un'altra valuta il
     Liquid lascia la soglia del paese in euro (data-soglia-base) e qui si converte con il cambio che Shopify mette nella pagina
     (Shopify.currency.rate, lo stesso dei prezzi). Se manca il cambio o la valuta della pagina non è quella del carrello: 0 = barra chiusa */
  MES.sogliaCent = (el) => {
    const fissa = Number(el.dataset.valoreSoglia); if (fissa > 0) return fissa;
    const base = Number(el.dataset.sogliaBase); const cur = window.Shopify && window.Shopify.currency;
    const cambio = cur ? Number(cur.rate) : NaN;
    if (!(base > 0) || !cur || !(cambio > 0) || !isFinite(cambio) || cur.active !== el.dataset.valuta) return 0;
    return Math.round(base * cambio);
  };
  /* soglia (21/10/2026): testo "Ti mancano X € alla spedizione gratis" / "Spedizione gratis sbloccata" e linea che si riempie
     (--soglia-quota). Dove sta: barra annunci (zona condivisa con il nastro: data-soglia-zona), striscia sotto l'header
     (data-soglia-striscia, solo senza <mes-annunci>), scheda (titolo delle garanzie, data-soglia-sempre: a carrello vuoto il titolo
     normale), drawer e pagina carrello (nascosta senza righe da spedire) */
  MES.soglia = (el, totaleSpedibile, nSpedibili) => {
    if (!el) return;
    const soglia = MES.sogliaCent(el);
    if (!soglia && !el.dataset.sogliaBase) return;
    const vuoto = !nSpedibili || !soglia;   // senza una soglia affidabile nella valuta del carrello la barra resta chiusa (22/10/2026)
    const ok = !vuoto && totaleSpedibile >= soglia;
    el.classList.toggle('soglia--raggiunta', ok); el.classList.toggle('soglia--vuota', vuoto);
    el.style.setProperty('--soglia-quota', vuoto ? '0' : Math.min(1, totaleSpedibile / soglia).toFixed(3));
    const testo = el.querySelector('[data-soglia-testo]');
    const mancano = (c) => (el.dataset.testoMancano || '').replace('{importo}', MES.importoValuta(c, el.dataset.valuta));
    if (testo) testo.textContent = vuoto ? (el.dataset.testoVuoto || mancano(soglia)) : ok ? el.dataset.testoOk : mancano(soglia - totaleSpedibile);
    const inerte = (x, si) => { if (!x) return; if (si) { x.setAttribute('inert', ''); x.setAttribute('aria-hidden', 'true'); } else { x.removeAttribute('inert'); x.removeAttribute('aria-hidden'); } };
    const zona = el.closest('[data-soglia-zona]');
    if (zona) { zona.classList.toggle('soglia-zona--attiva', !vuoto); inerte(el, vuoto); inerte(zona.querySelector('[data-soglia-altro]'), !vuoto); return; }
    const striscia = el.closest('[data-soglia-striscia]');
    if (striscia) { striscia.hidden = vuoto || !!document.querySelector('mes-annunci'); return; }
    if (el.dataset.sogliaSempre === undefined) el.hidden = vuoto;
  };
  MES.aggiornaSoglie = (totale, n) => document.querySelectorAll('[data-soglia]').forEach((el) => { if (!el.closest('mes-carrello')) MES.soglia(el, totale, n); });
  /* riga della spedizione in Italia sotto il subtotale (27/10/2026, snippet riga-spedizione): fuori dal carrello laterale (che si ridisegna da
     solo) segue lo stesso evento della barra; senza righe da spedire si nasconde */
  MES.aggiornaRigheSpedizione = (totale, n) => document.querySelectorAll('[data-riga-spedizione]').forEach((el) => {
    if (el.closest('mes-carrello')) return;
    const ok = totale >= Number(el.dataset.sogliaCent || 0);
    el.textContent = ok ? el.dataset.testoGratis : el.dataset.testoSotto;
    el.hidden = !n;
  });
  /* regalo sopra soglia (Black Friday 2026, 02/11/2026, snippet soglia-regalo): la stessa riga della soglia di spedizione, tre stati
     (sotto soglia / sbloccato senza il regalo nel carrello / regalo nel carrello). Il totale (righe da spedire al netto degli sconti, senza i
     prodotti in regalo e le gift card: snippet totale-regalo) e "regalo nel carrello" li calcola il Liquid del carrello laterale
     (data-regalo-totale, data-regalo-in) e arrivano con mes:carrello-cambiato; il carrello laterale si ridisegna da solo, qui si aggiorna
     la riga fuori da esso (pagina /cart). Solo in euro: con un'altra valuta il Liquid non la stampa */
  MES.regalo = (el, totale, inCarrello, nSpedibili) => {
    if (!el) return;
    const soglia = Number(el.dataset.sogliaCent || 0); if (!soglia) return;
    const ok = totale >= soglia;
    const vuoto = !nSpedibili;
    el.classList.toggle('soglia--raggiunta', ok || inCarrello); el.classList.toggle('soglia--vuota', vuoto);
    el.style.setProperty('--soglia-quota', (ok || inCarrello) ? '1' : Math.min(1, totale / soglia).toFixed(3));
    const testo = el.querySelector('[data-soglia-testo]');
    if (testo) {
      if (inCarrello) testo.textContent = el.dataset.testoIn || '';
      else if (ok) testo.innerHTML = el.dataset.htmlSbloccato || '';   // markup del tema (il nome del regalo è un link), scritto dal Liquid
      else testo.textContent = (el.dataset.testoMancano || '').replace('{importo}', MES.importoValuta(soglia - totale, 'EUR'));
    }
    el.hidden = vuoto;
  };
  MES.aggiornaRegali = (totale, inCarrello, n) => document.querySelectorAll('[data-soglia-regalo]').forEach((el) => { if (!el.closest('mes-carrello')) MES.regalo(el, totale, inCarrello, n); });
  document.addEventListener('mes:carrello-cambiato', (e) => { if (e.detail && typeof e.detail.regalo === 'number') MES.aDitoFermo(() => MES.aggiornaRegali(e.detail.regalo, !!e.detail.regaloIn, e.detail.spedibili)); });
  // a ogni cambio del carrello (il drawer manda i totali già netti): barra annunci, striscia e scheda si allineano; a dito fermo (regola dei tocchi)
  /* valuta diversa dall'euro: il Liquid ha lasciato le barre chiuse; al caricamento si convertono e si aprono a dito fermo (regola dei tocchi) */
  const sogliePerValuta = () => document.querySelectorAll('[data-soglia]').forEach((el) => {
    if (Number(el.dataset.valoreSoglia) > 0 || !el.dataset.sogliaBase) return;
    MES.aDitoFermo(() => MES.soglia(el, Number(el.dataset.totaleIniziale || 0), Number(el.dataset.nIniziale || 0)));
  });
  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', sogliePerValuta); else setTimeout(sogliePerValuta, 0);   // dopo il resto del file (MES.aDitoFermo)
  document.addEventListener('mes:carrello-cambiato', (e) => { if (e.detail && typeof e.detail.spedibile === 'number') MES.aDitoFermo(() => { MES.aggiornaSoglie(e.detail.spedibile, e.detail.spedibili); MES.aggiornaRigheSpedizione(e.detail.spedibile, e.detail.spedibili); }); });
  /* tessere animate (STRUTTURA 1.1). Al tocco la tessera parte e resta in moto finché la pagina cambia; il link fa il suo
     lavoro normale, nessuna attesa aggiunta. In più fa un giro da sola quando entra nello schermo (dopo il ritardo del
     blocco), poi si ferma sul primo fotogramma; se esce e rientra, riparte. Parte solo quando i tre fotogrammi sono
     scaricati, così non si vede mai un giro a metà. Con "riduci movimento" niente parte da solo. */
  {
    document.addEventListener('pointerdown', (e) => {
      const t = e.target.closest && e.target.closest('.tessera--animata');
      if (t) { t.classList.remove('tessera--giro'); t.classList.add('tessera--via'); }
    }, { passive: true });
    // il tocco è diventato uno scorrimento: la tessera non resta in moto (20/10/2026; prima un dito che partiva dalla tessera per
    // scorrere la lasciava animata per sempre)
    document.addEventListener('pointercancel', (e) => { const t = e.target.closest && e.target.closest('.tessera--via'); if (t) t.classList.remove('tessera--via'); }, { passive: true });
    // pagina tornata dalla cache del browser: la tessera toccata prima si ferma, la pagina non è cambiata
    window.addEventListener('pageshow', (e) => { if (e.persisted) document.querySelectorAll('.tessera--via').forEach((t) => t.classList.remove('tessera--via')); });
  }
  (() => {
    const tessere = document.querySelectorAll('.tessera--animata');
    if (!tessere.length || !('IntersectionObserver' in window)) return;
    const ridotto = matchMedia('(prefers-reduced-motion: reduce)');
    const pronta = (t) => Promise.all(Array.from(t.querySelectorAll('img')).map((img) => (img.complete && img.naturalWidth)
      ? Promise.resolve()
      : new Promise((ok) => { img.addEventListener('load', ok, { once: true }); img.addEventListener('error', ok, { once: true }); })));
    const giro = (t) => {
      if (ridotto.matches || t.classList.contains('tessera--via') || t.dataset.giroInCorso) return;
      t.dataset.giroInCorso = '1';
      pronta(t).then(() => {
        if (!t.dataset.visibile) { delete t.dataset.giroInCorso; return; }
        setTimeout(() => {
          if (!t.dataset.visibile || t.classList.contains('tessera--via')) { delete t.dataset.giroInCorso; return; }
          t.addEventListener('animationend', () => { t.classList.remove('tessera--giro'); delete t.dataset.giroInCorso; }, { once: true });
          t.classList.add('tessera--giro');
        }, Number(t.dataset.ritardo) || 0);
      });
    };
    const oss = new IntersectionObserver((voci) => voci.forEach((v) => {
      const t = v.target;
      if (v.isIntersecting) { t.dataset.visibile = '1'; giro(t); }
      else { delete t.dataset.visibile; t.classList.remove('tessera--giro'); delete t.dataset.giroInCorso; }
    }), { threshold: 0.6 });
    tessere.forEach((t) => oss.observe(t));
  })();
  /* immagini differite (02/10/2026, snippet immagine con differita: true): partono solo dopo che la foto principale della
     pagina (fetchpriority high) è disegnata, poi quando si avvicinano allo schermo. Una fila che scorre (riquadri,
     carosello) o una tessera si carica tutta insieme, così scorrendo di lato non compaiono buchi. */
  (() => {
    const imgs = document.querySelectorAll('img[data-differita]');
    if (!imgs.length) return;
    const carica = (img) => {
      const pic = img.parentElement && img.parentElement.tagName === 'PICTURE' ? img.parentElement : null;
      if (pic) pic.querySelectorAll('source[data-srcset]').forEach((s) => { s.srcset = s.dataset.srcset; s.removeAttribute('data-srcset'); });
      if (img.dataset.srcset) img.srcset = img.dataset.srcset;
      if (img.dataset.src) img.src = img.dataset.src;
      img.removeAttribute('data-differita'); img.removeAttribute('data-srcset'); img.removeAttribute('data-src');
    };
    const avvia = () => {
      if (!('IntersectionObserver' in window)) { imgs.forEach(carica); return; }
      const gruppi = new Map();
      imgs.forEach((img) => { const g = img.closest('.carosello, .entrate__fila, .tessera') || img.closest('.immagine') || img; if (!gruppi.has(g)) gruppi.set(g, []); gruppi.get(g).push(img); });
      const oss = new IntersectionObserver((voci) => voci.forEach((v) => {
        if (!v.isIntersecting) return;
        oss.unobserve(v.target); (gruppi.get(v.target) || []).forEach(carica);
      }), { rootMargin: '600px 0px' });
      gruppi.forEach((_, g) => oss.observe(g));
    };
    const dopoDisegno = () => requestAnimationFrame(() => requestAnimationFrame(avvia));
    const lcp = document.querySelector('img[fetchpriority="high"]');
    let partito = false; const unaVolta = () => { if (partito) return; partito = true; dopoDisegno(); };
    if (!lcp || (lcp.complete && lcp.naturalWidth)) unaVolta();
    else { lcp.addEventListener('load', unaVolta, { once: true }); lcp.addEventListener('error', unaVolta, { once: true }); setTimeout(unaVolta, 4000); }   // foto principale appesa (rete che cade): le altre partono comunque dopo 4 s (revisione del 20/10/2026)
  })();
  /* proprietà di riga (preordine): "Etichetta=valore" -> { Etichetta: valore }; visibili in ordine, email e admin */
  /* testo di una risposta (Section Rendering): una risposta non ok è un errore, non una pagina vuota da mostrare */
  MES.testo = async (url, opzioni) => { const r = await fetch(url, opzioni); if (!r.ok) throw new Error('HTTP ' + r.status); return r.text(); };
  /* messaggio leggibile da una risposta del carrello non ok (422: "già esaurito", "quantità massima"…); '' se non c'è */
  /* testo di un errore di Shopify: `description` è una stringa (giacenze) o un oggetto per campo (destinatario della gift card: { email: [...] }) */
  MES.testoErrore = (j) => { if (!j) return ''; const d = j.description; if (typeof d === 'string') return d; if (d && typeof d === 'object') return Object.values(d).flat().join('. '); return j.message || ''; };
  MES.messaggioRisposta = async (r) => { try { return MES.testoErrore(await r.json()); } catch (e) { return ''; } };
  /* caricamento a richiesta di un foglio di stile o di uno script (una volta sola): li usa il menu per i prodotti nei livelli */
  MES.caricaStile = (url) => new Promise((ok, ko) => { if (document.querySelector(`link[href="${url}"]`)) { ok(); return; } const l = document.createElement('link'); l.rel = 'stylesheet'; l.href = url; l.onload = () => ok(); l.onerror = () => { l.remove(); ko(new Error('css')); }; document.head.appendChild(l); });
  MES.caricaScript = (url) => new Promise((ok, ko) => { if (document.querySelector(`script[src="${url}"]`)) { ok(); return; } const s = document.createElement('script'); s.src = url; s.defer = true; s.onload = () => ok(); s.onerror = () => { s.remove(); ko(new Error('js')); }; document.head.appendChild(s); });
  /* consenso marketing (14/10/2026), stessa regola dello snippet klaviyo-consenso: vero se il visitatore ha accettato o se nella sua
     area il consenso non è richiesto. Una sola richiesta della Customer Privacy API per pagina. Nessun limite di tempo qui: chi
     aspetta decide da sé cosa mostrare nel frattempo (prodotto.js mostra "Paga subito" dopo 2 s e passa ai pulsanti se il sì arriva dopo) */
  MES.consensoMarketing = () => MES._consenso || (MES._consenso = new Promise((ok) => {
    const leggi = () => { const cp = window.Shopify && window.Shopify.customerPrivacy; try { return !!(cp && typeof cp.marketingAllowed === 'function' && cp.marketingAllowed()); } catch (e) { return false; } };
    if (window.Shopify && window.Shopify.customerPrivacy) { ok(leggi()); return; }
    if (!window.Shopify || typeof window.Shopify.loadFeatures !== 'function') { ok(false); return; }
    window.Shopify.loadFeatures([{ name: 'consent-tracking-api', version: '0.1' }], (errore) => ok(!errore && leggi()));
  }));
  /* "+" della card a riga (menu): mostra o nasconde il pannello delle taglie; lo usano il menu e la conferma dell'aggiunta */
  MES.apriTaglie = (b, apre) => { const taglie = b.closest('.card')?.querySelector('.card__taglie'); if (!taglie) return; taglie.hidden = !apre; b.setAttribute('aria-expanded', String(apre)); b.classList.toggle('card__piu--aperto', apre); if (apre) taglie.querySelector('[data-variante]:not([disabled])')?.focus({ preventScroll: true }); };
  /* esegue fn quando nessun dito è sullo schermo (revisione del 20/10/2026): contenuto cliccabile inserito o mostrato da una risposta di
     rete mentre un tocco è in corso fa perdere il tocco su iPhone (Safari lo scambia per un passaggio del mouse). Subito se nessun tocco
     è in corso; altrimenti 200 ms dopo l'ultimo touchend/touchcancel (la finestra di WebKit continua un po' dopo il touchend) */
  let ditoGiu = 0, ultimoTocco = 0;
  document.addEventListener('touchstart', (e) => { ditoGiu = e.touches.length; }, { passive: true, capture: true });
  document.addEventListener('touchend', (e) => { ditoGiu = e.touches.length; ultimoTocco = performance.now(); }, { passive: true, capture: true });
  document.addEventListener('touchcancel', (e) => { ditoGiu = e.touches.length; ultimoTocco = performance.now(); }, { passive: true, capture: true });
  MES.aDitoFermo = (fn) => {
    const prova = () => { if (!ditoGiu && performance.now() - ultimoTocco > 200) fn(); else setTimeout(prova, 60); };
    if (!ditoGiu && performance.now() - ultimoTocco > 200) fn(); else setTimeout(prova, 60);
  };
  MES.proprieta = (testo) => { if (!testo) return {}; const i = testo.indexOf('='); return i > 0 ? { [testo.slice(0, i)]: testo.slice(i + 1) } : {}; };
  MES.aggiornaContatore = (n) => {
    document.querySelectorAll('[data-carrello-contatore]').forEach((el) => { el.textContent = n; el.classList.toggle('header__contatore--vuoto', n === 0); });
    // singolare/plurale dai due testi preparati dal Liquid (voce 34): "1 articolo", "2 articoli"
    document.querySelectorAll('[data-carrello-testo]').forEach((el) => {
      const modello = (n === 1 ? el.dataset.testoUno : el.dataset.testoAltri) || el.textContent;
      el.textContent = modello.replace(/\d+/, n);
    });
  };

  const FOCUSABILI = 'a[href], button:not([disabled]), input:not([disabled]):not([type="hidden"]), select:not([disabled]), textarea:not([disabled]), summary, [tabindex]:not([tabindex="-1"])';
  const riduciMovimento = window.matchMedia('(prefers-reduced-motion: reduce)');

  /* ---------------------------------------------------------------- drawer */
  /* <mes-drawer>. Su telefono e tablet (sotto 990 px) un drawer con la classe .drawer--foglio è un FOGLIO che sale dal basso
     (25/09/2026, modello army33.it): angoli arrotondati, maniglia, si chiude trascinandolo verso il basso solo quando il
     contenuto è già in cima (altrimenti il dito scorre il contenuto), un pannello aperto alla volta, tasto indietro del
     telefono = chiude o torna al livello precedente, "riduci movimento" = niente scorrimento (la regola globale in base.css
     spegne le transizioni; qui non si aspetta nessun transitionend). Su computer resta il pannello laterale.
     LIVELLI (menu): [data-apri-livello="x"] apre il pannello [data-livello="x"] che scorre da destra dentro il foglio;
     [data-chiudi-livello] torna indietro. La cronologia tiene UNA voce sola per il drawer (pushState all'apertura,
     replaceState a ogni livello): al tasto indietro con un livello aperto si chiude il livello e si rimette la voce. */
  const RIDOTTO = window.matchMedia('(prefers-reduced-motion: reduce)');
  const DESKTOP = window.matchMedia('(min-width: 990px)');
  const COMANDI_TOCCO = 'a[href], button:not([disabled]), summary, label, [role="button"], [role="radio"], [role="checkbox"], [role="switch"], [role="tab"]';
  const traslazione = (el, asse) => { if (!el) return 0; const tr = getComputedStyle(el).transform; if (!tr || tr === 'none') return 0; const m = new DOMMatrixReadOnly(tr); return Math.abs(asse === 'x' ? m.m41 : m.m42); };
  /* tastiera e foglio (30/09/2026): con la tastiera aperta (campo della ricerca, prezzo Da/A dei filtri, note del carrello)
     iOS non ridimensiona la pagina, e un foglio ancorato in basso finirebbe per metà sotto la tastiera. Finché un foglio è
     aperto si ascolta il visualViewport: il foglio prende l'altezza visibile e si appoggia sopra la tastiera (variabili
     --vv-altezza e --vv-fondo sull'<html>, lette da .drawer--foglio). Senza tastiera le variabili non ci sono. */
  MES.fogliTastiera = (() => {
    const vv = window.visualViewport;
    const radice = document.documentElement;
    let attivo = false;
    const azzera = () => { radice.style.removeProperty('--vv-altezza'); radice.style.removeProperty('--vv-fondo'); radice.classList.remove('tastiera-aperta'); };
    const aggiorna = (v) => {
      const m = (v && typeof v.height === 'number') ? v : vv;
      if (!m) return;
      const differenza = window.innerHeight - m.height;
      if (differenza < 100) { azzera(); return; }   // sotto i 100 px è la barra del browser che si muove, non la tastiera
      radice.style.setProperty('--vv-altezza', Math.round(m.height) + 'px');
      radice.style.setProperty('--vv-fondo', Math.max(0, Math.round(differenza - m.offsetTop)) + 'px');
      radice.classList.add('tastiera-aperta');   // con la tastiera il banner dei cookie resta dietro: il foglio non si alza due volte (base.css)
    };
    const avvia = () => { if (attivo || !vv) return; attivo = true; vv.addEventListener('resize', aggiorna); vv.addEventListener('scroll', aggiorna); aggiorna(); };
    const ferma = () => { if (!attivo) return; attivo = false; vv.removeEventListener('resize', aggiorna); vv.removeEventListener('scroll', aggiorna); };
    return { avvia, ferma, azzera, aggiorna };
  })();
  /* banner dei cookie di Shopify (14/10/2026): finché è aperto copre il fondo dello schermo, e "Vai al checkout" del carrello
     finiva sotto (test del 14/10: 0 prove di acquisto su 10 prima della scelta). Si misura dal vivo quanto copre, dal suo bordo
     alto al fondo della finestra (barra di anteprima compresa), e lo si scrive in --banner-cookie sull'<html>: pannelli, barra
     fissa, pulsante WhatsApp e fondo della pagina salgono di altrettanto (base.css, prodotto.css). Shopify mette il banner come
     figlio del <body> e alla scelta gli dà display: none: la variabile torna a zero e tutto riscende. Conta solo un banner
     appoggiato in fondo: con la posizione "Centro" non si alza niente. */
  MES.bannerCookie = (() => {
    const radice = document.documentElement;
    let banner = null, ro = null, mo = null, ultimo = -1;
    const aggiorna = () => {
      let h = 0;
      if (banner && banner.isConnected) {
        const r = banner.getBoundingClientRect(), cs = getComputedStyle(banner);
        if (cs.display !== 'none' && cs.visibility !== 'hidden' && r.height > 0 && r.bottom >= window.innerHeight - 120) h = Math.max(0, Math.round(window.innerHeight - r.top));
      }
      if (h === ultimo) return;
      ultimo = h;
      if (h) radice.style.setProperty('--banner-cookie', h + 'px'); else radice.style.removeProperty('--banner-cookie');
      radice.classList.toggle('banner-cookie-aperto', h > 0);
    };
    const aggancia = () => {
      const b = document.getElementById('shopify-pc__banner');
      if (b !== banner) {
        if (ro) ro.disconnect();
        if (mo) mo.disconnect();
        banner = b;
        if (banner) {
          if ('ResizeObserver' in window) { ro = new ResizeObserver(aggiorna); ro.observe(banner); }
          mo = new MutationObserver(aggiorna); mo.observe(banner, { attributes: true, attributeFilter: ['style', 'class', 'hidden'] });
        }
      }
      aggiorna();
    };
    new MutationObserver(aggancia).observe(document.body, { childList: true });
    window.addEventListener('resize', aggiorna);
    document.addEventListener('visitorConsentCollected', () => setTimeout(aggiorna, 50));
    aggancia();
    return { aggiorna };
  })();
  /* Pulsante WhatsApp (16/10/2026): fisso in basso a destra, scorrendo finiva sopra le taglie e il "+" delle card e sulla
     tessera Donna della 404. Quando sotto il suo cerchio c'è un comando (pulsante, anche un link .pulsante, taglia, campo, tessera,
     stelle del voto in scheda: aggiunti il 18/10/2026) si fa da parte
     (classe whatsapp--via: dissolvenza, non toccabile) e torna appena è libero. Un controllo per fotogramma, solo a scorrimento
     e ridimensionamento; elementsFromPoint guarda sotto il pulsante senza spostarlo. */
  /* Fascia delle garanzie con le illustrazioni a due frame (16/10/2026): l'alternanza è un'animazione CSS infinita; qui solo la
     pausa quando la fascia non è sullo schermo (classe garanzie-fascia--ferma), che riparte da sola quando torna visibile. */
  MES.garanzieFrame = (() => {
    const fasce = document.querySelectorAll('[data-garanzie-frame]');
    if (!fasce.length || !('IntersectionObserver' in window)) return null;
    const io = new IntersectionObserver((voci) => voci.forEach((v) => v.target.classList.toggle('garanzie-fascia--ferma', !v.isIntersecting)));
    fasce.forEach((f) => { f.classList.add('garanzie-fascia--ferma'); io.observe(f); });
    return io;
  })();
  MES.whatsappLibero = (() => {
    const w = document.querySelector('.whatsapp');
    if (!w) return null;
    const COMANDI = 'button, label, input, select, textarea, summary, [role="button"], .tessera, .pulsante, .prodotto__stelle';
    let atteso = false;
    const controlla = () => {
      atteso = false;
      const r = w.getBoundingClientRect();
      if (!r.width) return;
      const m = 4, cx = r.left + r.width / 2, cy = r.top + r.height / 2;
      const punti = [[cx, cy], [r.left + m, r.top + m], [r.right - m, r.top + m], [r.left + m, r.bottom - m], [r.right - m, r.bottom - m], [cx, r.top + 1], [cx, r.bottom - 1], [r.left + 1, cy], [r.right - 1, cy]];
      const sotto = punti.some(([x, y]) => document.elementsFromPoint(x, y).some((el) => el !== w && !w.contains(el) && el.closest(COMANDI) && !el.closest('.whatsapp')));
      w.classList.toggle('whatsapp--via', sotto);
    };
    const pianifica = () => { if (!atteso) { atteso = true; requestAnimationFrame(controlla); } };
    window.addEventListener('scroll', pianifica, { passive: true });
    window.addEventListener('resize', pianifica);
    new ResizeObserver(pianifica).observe(document.body);
    pianifica();
    return { controlla: pianifica };
  })();
  const doppioFrame = (fn) => requestAnimationFrame(() => requestAnimationFrame(fn));
  const dopoTransizione = (el, proprieta, fn, massimo) => {
    if (RIDOTTO.matches) { fn(); return; }
    let fatto = false;
    const fine = (e) => { if (e && e.target !== el) return; if (e && proprieta && e.propertyName !== proprieta) return; if (fatto) return; fatto = true; el.removeEventListener('transitionend', fine); fn(); };
    el.addEventListener('transitionend', fine);
    setTimeout(() => fine(), massimo || 450);
  };

  class MesDrawer extends HTMLElement {
    constructor() {
      super();
      this.velo = document.querySelector('[data-velo]');
      this.pannello = this.querySelector('.drawer__pannello');
      this.aperto = false;
      this.livelli = [];
      this._suTasto = this._suTasto.bind(this);
      this._suPopstate = this._suPopstate.bind(this);
    }

    get eFoglio() { return this.classList.contains('drawer--foglio') && !DESKTOP.matches; }

    /* collegamento (30/09/2026, idempotente): collezione.js e prodotto.js lo richiamano dopo un render, il carrello sostituisce il
       proprio innerHTML a ogni aggiornamento. Tutto in delega sull'host (chiudi, livelli, "+") o su document (i pulsanti
       [data-apri] fuori dal drawer, trovati al momento del tocco: valgono anche quelli arrivati dopo, come la barra dei filtri
       o la scheda del fratello), legato UNA volta; il trascinamento sta sull'host e rilegge il pannello a ogni evento. */
    connectedCallback() {
      this._collegaOrigini();
      // in fase di cattura: il preventDefault arriva prima di ogni altro ascoltatore (es. la pressione che resta sui link), a
      // prescindere dall'ordine in cui i drawer sono stati definiti (il carrello arriva da carrello.js, dopo)
      if (!this._suClickDocumento) this._suClickDocumento = (e) => { const b = e.target.closest(`[data-apri="${this.id}"]`); if (!b || this.contains(b) || e.button !== 0 || e.metaKey || e.ctrlKey || e.shiftKey || e.altKey) return; e.preventDefault(); this.apri(b); };
      document.addEventListener('click', this._suClickDocumento, true);
      if (this._collegato) return;
      this._collegato = true;
      // registro dei click veri (prima di ogni altro ascoltatore): la tolleranza del tocco (_trascinamento) manda il suo click solo se
      // il browser non ne ha mandato uno; e il click vero che arrivasse dopo quello del tema non ripete l'azione
      this.addEventListener('click', (e) => {
        if (!e.isTrusted) return;
        const s = this._sintetico;
        if (s && performance.now() - s.alle < 800 && s.el.contains(e.target)) { e.preventDefault(); e.stopImmediatePropagation(); return; }
        this._ultimoClic = performance.now();
      }, true);
      this.addEventListener('click', (e) => {
        const t = e.target;
        const ora = performance.now();
        // Tocchi durante il movimento (19/10/2026; prima, dal 14/10, 320 ms dopo l'apertura e 400 ms dopo un cambio di livello a tempo
        // fisso: a foglio già fermo scartavano tocchi voluti, per esempio Donna → Boxy, che stanno sulla stessa riga). Ora conta la
        // posizione vera: si scarta solo finché il foglio è a più di 16 px dal suo posto, cioè mentre le voci scorrono sotto il dito
        const salita = this._salita();
        if (salita > 16 && this.pannello?.contains(t)) { e.preventDefault(); return; }
        // doppio tocco su una voce che cambia livello: il secondo tocco cade sulla voce che compare nello stesso punto (Donna → Boxy,
        // stessa riga). Si scarta solo se arriva entro 30 px dal primo e mentre il livello è ancora a più di 16 px dal suo posto, o
        // comunque entro 250 ms (nessuno riesce a vedere e mirare una voce nuova così in fretta; vale anche con "riduci movimento",
        // dove il livello non scorre). A livello fermo un tocco su Boxy passa sempre
        const moto = e.detail > 0 ? this._livelloInMoto() : null;
        if (e.detail > 0 && this._cambioXY && (moto || ora - (this._cambioAlle || 0) < 250) && Math.hypot(e.clientX - this._cambioXY[0], e.clientY - this._cambioXY[1]) < 30) { e.preventDefault(); return; }
        // livello che arriva ancora lontano dal suo posto: le righe non si muovono in verticale, quindi un tocco va alla voce che
        // starà in quel punto. Il livello sotto è inert e il tocco arriva al contenitore: lo si inoltra
        if (moto && moto.entrante && !t.closest('.menu__livello')) {
          const dest = this._comandoFinale(moto.el, e.clientX, e.clientY);
          if (dest) { e.preventDefault(); dest.click(); return; }
        }
        const segna = () => { this._cambioAlle = ora; this._cambioXY = e.detail > 0 ? [e.clientX, e.clientY] : null; };
        if (t.closest('[data-chiudi]')) { this.chiudi(); return; }
        if (t.closest('[data-chiudi-livello]')) { segna(); this.chiudiLivello(); return; }
        const gruppo = t.closest('[data-apri-livello]');
        if (gruppo) { e.preventDefault(); segna(); this.apriLivello(gruppo.dataset.apriLivello, gruppo); return; }
        // livelli con i prodotti (29/09/2026): la voce punta a una collezione; con JS apre un livello caricato a richiesta
        const remoto = t.closest('[data-apri-livello-url]');
        if (remoto) { e.preventDefault(); segna(); this.apriLivelloRemoto(remoto); return; }
        // "+" sulla card nel menu: mostra o nasconde le taglie (durante un'aggiunta il pannello resta aperto)
        const piu = t.closest('[data-piu]');
        if (piu) { const taglie = piu.closest('.card')?.querySelector('.card__taglie'); if (taglie && !taglie._inCorso) MES.apriTaglie(piu, taglie.hidden); }
      });
      // le voci-pulsante (link con role=button) rispondono anche alla barra spaziatrice
      this.addEventListener('keydown', (e) => {
        if (e.key !== ' ') return;
        const a = e.target.closest('[data-apri-livello], [data-apri-livello-url]');
        if (!a) return;
        e.preventDefault();
        if (a.dataset.apriLivello) this.apriLivello(a.dataset.apriLivello, a); else this.apriLivelloRemoto(a);
      });
      // precarico dei livelli con i prodotti (21/10/2026): al dito sulla freccia la richiesta parte subito, prima del click
      const anticipo = (e) => { const a = e.target.closest && e.target.closest('[data-apri-livello-url]'); if (a) this._caricaLivello(a.dataset.apriLivelloUrl, { subito: true }); };
      this.addEventListener('pointerdown', anticipo, { passive: true });
      this.addEventListener('touchstart', anticipo, { passive: true });
      if (this.classList.contains('drawer--foglio')) this._trascinamento();
    }

    /* tolto dalla pagina (es. la scheda del fratello via Section Rendering ricrea il drawer della guida taglie): il pulsante
       nuovo non deve aprire il drawer vecchio, e se era aperto non restano velo, blocco della pagina o voce di cronologia */
    disconnectedCallback() {
      document.removeEventListener('click', this._suClickDocumento, true);
      if (!this.aperto) return;
      this.aperto = false;
      if (this.velo) this.velo.removeEventListener('click', this._veloClick);
      document.removeEventListener('keydown', this._suTasto);
      window.removeEventListener('popstate', this._suPopstate);
      if (history.state && history.state.drawer === this.id) history.replaceState({}, '', location.href);
      if (!Array.from(document.querySelectorAll('.drawer')).some((d) => d.aperto)) { if (this.velo) { this.velo.hidden = true; this.velo.style.opacity = ''; this.velo.style.pointerEvents = ''; } document.body.classList.remove('drawer-aperto'); MES.fogliTastiera.ferma(); MES.fogliTastiera.azzera(); }
    }

    /* quanto manca al foglio per arrivare al suo posto (px): durante la salita le voci scorrono sotto il dito */
    _salita() { return this.eFoglio && this.pannello && !this.classList.contains('drawer--trascino') ? traslazione(this.pannello, 'y') : 0; }
    /* livello che scorre davvero (più di 16 px dal suo posto): quello che arriva o quello che esce */
    _livelloInMoto() {
      const arrivo = this.livelli.length ? this.livelli[this.livelli.length - 1].el : null;
      if (arrivo && traslazione(arrivo, 'x') > 16) return { el: arrivo, entrante: true };
      const u = this._uscente;
      if (u && !u.hidden) { const tx = traslazione(u, 'x'); if (tx > 16 && tx < u.offsetWidth - 16) return { el: u, entrante: false }; }
      return null;
    }
    /* la voce del livello che arriva che, a livello fermo, starà sotto il punto (x, y): le righe sono già alla loro altezza */
    _comandoFinale(livello, x, y) {
      const tx = livello.getBoundingClientRect().left - (this.querySelector('[data-livelli]')?.getBoundingClientRect().left || 0);
      return Array.from(livello.querySelectorAll('a[href], button:not([disabled]), [role="button"]')).find((c) => {
        const r = c.getBoundingClientRect();
        return r.width > 0 && x >= r.left - tx && x <= r.right - tx && y >= r.top && y <= r.bottom;
      }) || null;
    }

    /* ruolo e stato delle voci-pulsante (senza JS restano link) e dei pulsanti di apertura, anche se un render li ha rifatti */
    _collegaOrigini() {
      this.querySelectorAll('[data-apri-livello]').forEach((a) => { a.setAttribute('role', 'button'); if (!a.hasAttribute('aria-expanded')) a.setAttribute('aria-expanded', 'false'); const p = this.querySelector(`[data-livello="${a.dataset.apriLivello}"]`); if (p?.id) a.setAttribute('aria-controls', p.id); });
      this.querySelectorAll('[data-apri-livello-url]').forEach((a) => { a.setAttribute('role', 'button'); if (!a.hasAttribute('aria-expanded')) a.setAttribute('aria-expanded', 'false'); });
      document.querySelectorAll(`[data-apri="${this.id}"]`).forEach((b) => { if (b.hasAttribute('aria-expanded')) b.setAttribute('aria-expanded', String(this.aperto)); });
      // il pulsante di apertura è stato sostituito (barra dei filtri dopo un filtro applicato): l'origine diventa quello nuovo
      if (this.aperto && (!this.origine || !this.origine.isConnected)) this.origine = this._pulsanteApri();
    }

    /* il pulsante di apertura visibile, di preferenza fuori dai drawer (header, barra dei filtri, scheda) */
    _pulsanteApri() {
      const tutti = Array.from(document.querySelectorAll(`[data-apri="${this.id}"]`)).filter((b) => b.getClientRects().length > 0);
      return tutti.find((b) => !b.closest('.drawer')) || tutti[0] || null;
    }

    /* livello caricato a richiesta: la sezione "menu-prodotti" renderizzata sull'indirizzo della collezione. Il livello si apre
       SUBITO con "Un attimo…" (così il tocco ha una risposta e il resto del menu resta usabile); CSS e JS della collezione si
       caricano una volta sola prima di inserire le card (niente lampo senza stile). Un livello per URL, tenuto in cache:
       se l'utente torna indietro mentre carica, la risposta riempie il livello nascosto e il tocco dopo lo apre subito.
       Se qualcosa va storto: messaggio e link alla collezione dentro il livello, e al tocco dopo si riprova. */
    /* ---- precarico dei livelli con i prodotti (21/10/2026, istruzioni dell'utente) ----
       Quando il menu si apre, in idle, si scaricano in sottofondo le sezioni dei livelli che hanno la freccia nel livello visibile
       (al massimo 3 richieste alla volta); lo stesso quando si apre un sottolivello. Al dito sulla freccia la richiesta di quel
       livello parte subito, fuori dalla coda. Le risposte restano in memoria per tutta la visita (Map) e in sessionStorage per 10
       minuti. All'arrivo dell'HTML si precaricano le prime 4 foto (new Image con lo stesso srcset/sizes delle card). Niente di
       tutto questo tocca il DOM: quello che si vede cambia solo quando il livello viene aperto. Senza apertura del menu non parte
       nessuna richiesta. */
    _inIdle(fn) { if (window.requestIdleCallback) requestIdleCallback(fn, { timeout: 1200 }); else setTimeout(fn, 200); }

    _precaricaLivelli(livello, { risorse = false } = {}) {
      const nav = this.querySelector('[data-livelli]');
      if (!livello || !nav) return;
      this._inIdle(() => {
        if (!this.aperto) return;
        if (risorse) {
          // CSS e JS della collezione (servono alle card): in cache prima dell'apertura del primo livello, senza applicarli adesso
          [['css', 'style'], ['js', 'script']].forEach(([k, come]) => {
            const u = nav.dataset[k]; if (!u || document.querySelector(`link[href="${u}"], script[src="${u}"]`)) return;
            const l = document.createElement('link'); l.rel = 'preload'; l.as = come; l.href = u; document.head.appendChild(l);
          });
        }
        livello.querySelectorAll('[data-apri-livello-url]').forEach((a) => this._caricaLivello(a.dataset.apriLivelloUrl).catch(() => {}));
      });
    }

    _caricaLivello(url, { subito = false } = {}) {
      const cache = MesDrawer.livelliCache || (MesDrawer.livelliCache = new Map());
      const voce = cache.get(url);
      if (voce) { if (subito) voce.avvia(); return voce.promessa; }
      const chiave = 'mes-menu:' + url;
      try {
        const s = JSON.parse(sessionStorage.getItem(chiave) || 'null');
        if (s && s.html && Date.now() - s.t < 600000) { const promessa = Promise.resolve(s.html); cache.set(url, { promessa, avvia() {} }); this._precaricaFoto(s.html); return promessa; }
      } catch (e) { /* storage non disponibile */ }
      let ok, ko; const promessa = new Promise((a, b) => { ok = a; ko = b; });
      const indirizzo = url + (url.includes('?') ? '&' : '?') + 'section_id=menu-prodotti';
      let corsa = null;
      const avvia = () => {
        if (corsa) return corsa;
        corsa = (async () => {
          try {
            let html = null;
            for (let tentativo = 0; tentativo < 2 && !html; tentativo++) {   // una risposta storta capita: si riprova una volta
              try { const el = new DOMParser().parseFromString(await MES.testo(indirizzo), 'text/html').querySelector('[data-menu-prodotti]'); html = el ? el.outerHTML : null; } catch (e) { if (tentativo) throw e; }
            }
            if (!html) throw new Error('sezione senza contenuto');
            try { if (html.length < 300000) sessionStorage.setItem(chiave, JSON.stringify({ t: Date.now(), html })); } catch (e) { /* pieno o vietato */ }
            this._precaricaFoto(html);
            ok(html);
          } catch (err) { cache.delete(url); ko(err); }   // al tocco dopo si riprova
        })();
        return corsa;
      };
      cache.set(url, { promessa, avvia });
      if (subito) avvia(); else MesDrawer._accoda(avvia);
      return promessa;
    }

    static _accoda(fn) {
      const q = MesDrawer._coda || (MesDrawer._coda = { attesa: [], inCorso: 0 });
      q.attesa.push(fn); MesDrawer._giraCoda();
    }
    static _giraCoda() {
      const q = MesDrawer._coda; if (!q) return;
      while (q.inCorso < 3 && q.attesa.length) {
        const fn = q.attesa.shift(); q.inCorso++;
        Promise.resolve().then(fn).catch(() => {}).finally(() => { q.inCorso--; MesDrawer._giraCoda(); });
      }
    }

    _precaricaFoto(html) {
      const tenute = MesDrawer._foto || (MesDrawer._foto = []);
      try {
        const doc = new DOMParser().parseFromString(html, 'text/html');
        Array.from(doc.querySelectorAll('.menu__prodotti-lista img')).slice(0, 4).forEach((img) => {
          const src = img.getAttribute('src'); if (!src || tenute.some((t) => t.dataset.chiave === src)) return;
          const im = new Image(); im.dataset.chiave = src;
          if (img.getAttribute('sizes')) im.sizes = img.getAttribute('sizes');
          if (img.getAttribute('srcset')) im.srcset = img.getAttribute('srcset');
          im.src = src;
          tenute.push(im); if (tenute.length > 80) tenute.shift();
        });
      } catch (e) { /* niente: le foto arrivano al tocco */ }
    }

    _scheletro(n) {
      let righe = '';
      for (let i = 0; i < n; i++) righe += '<li class="menu__scheletro"><span class="menu__scheletro-foto"></span></li>';
      return `<ul class="menu__prodotti-lista menu__prodotti-lista--attesa" aria-hidden="true">${righe}</ul>`;
    }

    async apriLivelloRemoto(a) {
      const nav = this.querySelector('[data-livelli]');
      const url = a.dataset.apriLivelloUrl;
      const id = 'remoto-' + url.replace(/[^a-z0-9]+/gi, '-').replace(/^-|-$/g, '');
      let livello = this.querySelector(`[data-livello="${id}"]`);
      if (!livello) {
        livello = document.createElement('div');
        livello.className = 'menu__livello';
        livello.dataset.livello = id;
        livello.id = 'menu-livello-' + id;
        livello.hidden = true;
        const titolo = a.dataset.livelloTitolo || a.textContent.trim();
        const freccia = this.querySelector('.menu__indietro-icona')?.innerHTML || '';
        const indietro = document.createElement('button');
        indietro.type = 'button'; indietro.className = 'tocco menu__indietro'; indietro.setAttribute('data-chiudi-livello', '');
        indietro.setAttribute('aria-label', `${nav?.dataset.indietro || ''}: ${titolo}`);
        indietro.innerHTML = `<span class="menu__indietro-icona" aria-hidden="true">${freccia}</span>`;
        indietro.append(titolo);   // il click lo gestisce la delega sull'host ([data-chiudi-livello]): un ascoltatore diretto lo farebbe scattare due volte
        const corpo = document.createElement('div');
        corpo.className = 'menu__prodotti'; corpo.setAttribute('data-menu-prodotti', '');
        livello.append(indietro, corpo);
        nav?.appendChild(livello);
      }
      a.setAttribute('aria-controls', livello.id);
      this.apriLivello(id, a);
      if (livello.dataset.caricato || livello.dataset.caricando) return;
      livello.dataset.caricando = '1';
      const corpo = livello.querySelector('[data-menu-prodotti]');
      // in attesa: righe segnaposto arancioni alte quanto le card, senza testo (21/10/2026; prima "Un attimo…" e poi caselle bianche).
      // Con l'HTML già in memoria (precarico) la sostituzione arriva nello stesso giro, prima del disegno: lo scheletro non si vede
      corpo.innerHTML = this._scheletro(6);
      corpo.setAttribute('aria-busy', 'true');
      try {
        const [html] = await Promise.all([this._caricaLivello(url, { subito: true }), nav?.dataset.css ? MES.caricaStile(nav.dataset.css) : null, nav?.dataset.js ? MES.caricaScript(nav.dataset.js) : null]);
        const nuovo = new DOMParser().parseFromString(html, 'text/html').querySelector('[data-menu-prodotti]');
        if (!nuovo) throw new Error('sezione senza contenuto');
        // collezione vuota o inesistente: il link in fondo porta all'indirizzo della voce (Liquid non lo conosce: 404 = "/404")
        if (!nuovo.querySelector('.card')) nuovo.querySelectorAll('.menu__prodotti-tutti').forEach((l) => l.setAttribute('href', url));
        corpo.replaceWith(nuovo);
        livello.dataset.caricato = '1';
      } catch (err) {
        console.warn('menu: livello non caricato', url, err && err.message);
        corpo.innerHTML = `<p class="menu__caricamento">${nav?.dataset.errore || ''}</p><a class="pulsante pulsante--secondario menu__prodotti-tutti" href="${url}">${nav?.dataset.vaiCollezione || url}</a>`;
      } finally {
        corpo.removeAttribute('aria-busy');
        delete livello.dataset.caricando;
      }
    }

    /* stato della voce di cronologia del drawer: profondità e percorso dei livelli ("voce-2" per un livello del menu, "url:/collections/…" per
       un livello di prodotti), così tornando su questa voce il menu si riapre com'era (20/10/2026). `base` conserva le altre chiavi della
       voce (per esempio mesVoce dello script del ritorno) nei replaceState; nei pushState la voce è nuova e parte vuota */
    _stato(base) { return Object.assign({}, base || {}, { drawer: this.id, livello: this.livelli.length, percorso: this.livelli.map((l) => l.chiave) }); }

    /* riapre il menu com'era da una voce di cronologia (pagina ricaricata con Indietro con in cima la voce del drawer): stessi livelli,
       senza aggiungere voci. Un livello che non esiste più ferma il percorso */
    ripristina(stato) {
      if (this.aperto || !stato || stato.drawer !== this.id) return;
      this.apri(null, { senzaHistory: true });
      (stato.percorso || []).every((chiave) => {
        if (typeof chiave !== 'string') return false;
        if (chiave.slice(0, 4) === 'url:') { const a = this.querySelector(`[data-apri-livello-url="${CSS.escape(chiave.slice(4))}"]`); if (!a) return false; this.apriLivelloRemoto(a); return true; }
        const a = this.querySelector(`[data-apri-livello="${CSS.escape(chiave)}"]`); if (!a) return false; this.apriLivello(chiave, a); return true;
      });
      if (history.state && history.state.drawer === this.id) history.replaceState(this._stato(history.state), '');
    }

    apri(origine, { senzaHistory = false } = {}) {
      if (this.aperto) return;
      // un pannello aperto alla volta: l'altro si chiude senza toccare la cronologia, e questo ne riusa la voce (replaceState)
      let sostituisce = false;
      const attivo = document.activeElement;
      let origineVisibile = origine || (attivo && attivo !== document.body ? attivo : null) || this._pulsanteApri();   // dopo un'aggiunta il pulsante era disabled e il focus è sul body: si ripiega sull'icona dell'header
      document.querySelectorAll('.drawer:not([hidden])').forEach((d) => {
        if (d === this || typeof d.chiudi !== 'function' || !d.aperto) return;
        sostituisce = true;
        // l'origine sta nel drawer che si chiude (es. "Vai al carrello" dentro il menu): focus e stato vanno al pulsante dell'header
        if (origineVisibile && d.contains(origineVisibile)) origineVisibile = this._pulsanteApri() || d.origine || null;
        d.chiudi({ senzaFocus: true, senzaHistory: true });
      });
      if (!this.pannello) this.pannello = this.querySelector('.drawer__pannello');
      if (!this.pannello) return;
      this.aperto = true;
      this.origine = origineVisibile;
      this.origine?.classList?.remove('andando');   // un link che apre un drawer non "porta a una pagina": torna pieno
      this.urlApertura = location.href;
      this.hidden = false;
      // riparte pulito anche se una chiusura (trascinamento, transizione) era ancora in corso
      this.classList.remove('drawer--trascino'); this.pannello.style.transform = ''; this._azzeraLivelli();
      // il velo non chiude nei primi 400 ms: il foglio sta ancora salendo e il secondo tocco di un doppio tocco sull'hamburger (o un
      // tocco dove comparirà una voce) cadeva sul velo e richiudeva il menu (14/10/2026)
      this._apertoAlle = performance.now();
      if (this.velo) { this.velo.hidden = false; this.velo.style.opacity = ''; this.velo.style.pointerEvents = ''; this.velo.addEventListener('click', this._veloClick = () => { if (performance.now() - this._apertoAlle > 400 && this._salita() <= 16) this.chiudi(); }); }   // tocco sul velo mentre il foglio sale: non chiude
      document.body.classList.add('drawer-aperto');
      document.addEventListener('keydown', this._suTasto);
      // tasto indietro del telefono chiude il drawer (una voce di cronologia per tutto il drawer, livelli compresi)
      if (senzaHistory) { /* ripristino da una voce già in cima (pagina ricaricata con Indietro): la voce c'è già */ }
      else if (sostituisce && history.state && history.state.drawer) history.replaceState(this._stato(history.state), '');
      else history.pushState(this._stato(), '');
      window.addEventListener('popstate', this._suPopstate);
      if (this.origine?.hasAttribute('aria-expanded')) this.origine.setAttribute('aria-expanded', 'true');
      if (this.eFoglio) { doppioFrame(() => this.classList.add('drawer--aperto')); MES.fogliTastiera.avvia(); } else this.classList.add('drawer--aperto');
      const daFocalizzare = this.dataset.focus ? this.querySelector(this.dataset.focus) : null;
      // un campo di testo si focalizza SUBITO, dentro il gesto: iOS apre la tastiera solo così (il foglio sale intanto)
      if (daFocalizzare) daFocalizzare.focus({ preventScroll: true }); else requestAnimationFrame(() => this.pannello.focus({ preventScroll: true }));
      this.dispatchEvent(new CustomEvent('mes:drawer-aperto', { bubbles: true }));
      this._precaricaLivelli(this.querySelector('.menu__livello--radice'), { risorse: true });
    }

    chiudi({ daHistory = false, senzaFocus = false, senzaHistory = false } = {}) {
      if (!this.aperto) return;
      this.aperto = false;
      if (this.velo) this.velo.removeEventListener('click', this._veloClick);
      document.removeEventListener('keydown', this._suTasto);
      window.removeEventListener('popstate', this._suPopstate);
      if (!daHistory && !senzaHistory && history.state && history.state.drawer === this.id) {
        // una voce del drawer ha già fatto partire una pagina nuova (19/10/2026): history.back() annullerebbe il cambio di pagina,
        // quindi la cronologia resta com'è (la voce in più la toglie pageshow al ritorno)
        if (MES.inPartenza && performance.now() - MES.inPartenza < 15000) { /* la voce resta: la toglie pageshow al ritorno */ }
        // se dentro il drawer l'indirizzo è cambiato (filtri via AJAX), la voce del drawer diventa la pagina filtrata
        else if (location.href !== this.urlApertura) history.replaceState({}, '', location.href);
        else { history.back(); }
      }
      if (this.origine?.hasAttribute('aria-expanded')) this.origine.setAttribute('aria-expanded', 'false');
      if (!senzaFocus) { const o = this.origine; const visibile = o && o.isConnected && !o.disabled && o.getClientRects().length > 0 && getComputedStyle(o).visibility !== 'hidden'; (visibile ? o : this._pulsanteApri())?.focus({ preventScroll: true }); }
      // velo e blocco della pagina restano finché il foglio non è sceso; se un altro drawer ha preso il posto, restano a lui
      const altroAperto = () => Array.from(document.querySelectorAll('.drawer')).some((d) => d.aperto);
      const spegni = () => { if (altroAperto()) return; if (this.velo) { this.velo.hidden = true; this.velo.style.opacity = ''; this.velo.style.pointerEvents = ''; } document.body.classList.remove('drawer-aperto'); MES.fogliTastiera.azzera(); };
      if (!altroAperto()) { MES.fogliTastiera.ferma(); MES.fogliTastiera.azzera(); }   // la scatola torna subito a tutta altezza: il bordo alto non si muove, il foglio si allunga dietro la tastiera che si ritira e translateY(100%) lo porta tutto fuori schermo
      const fine = () => { if (this.aperto) return; this.hidden = true; this.pannello.style.transform = ''; this._azzeraLivelli(); spegni(); };   // guardia: riaperto prima della fine
      this.classList.remove('drawer--trascino');
      const scorre = this.eFoglio && this.classList.contains('drawer--aperto');
      if (scorre && this.velo && !altroAperto()) { this.velo.style.opacity = '0'; this.velo.style.pointerEvents = 'none'; }   // sfuma ma non blocca i tocchi: l'hamburger risponde subito
      this.classList.remove('drawer--aperto');
      if (scorre) dopoTransizione(this.pannello, 'transform', fine, 450); else fine();
      this.dispatchEvent(new CustomEvent('mes:drawer-chiuso', { bubbles: true }));
    }

    /* ---- livelli (menu a pannelli) ---- */
    apriLivello(id, origine) {
      const livello = this.querySelector(`[data-livello="${id}"]`);
      if (!livello || this.livelli.some((l) => l.el === livello)) return;
      // il livello sotto resta visibile ai lati dell'animazione ma non deve ricevere focus né tocchi: inert
      const sotto = this.livelli.length ? this.livelli[this.livelli.length - 1].el : this.querySelector('.menu__livello--radice');
      if (sotto) sotto.inert = true;
      this.livelli.push({ el: livello, origine, chiave: origine && origine.dataset.apriLivelloUrl ? 'url:' + origine.dataset.apriLivelloUrl : id });
      if (this._uscente === livello) this._uscente = null;
      livello.inert = false;   // poteva essere un livello che stava uscendo (vedi chiudiLivello)
      livello.hidden = false;
      livello.scrollTop = 0;
      origine?.setAttribute('aria-expanded', 'true');
      if (this.eFoglio && !RIDOTTO.matches) doppioFrame(() => livello.classList.add('menu__livello--aperto')); else livello.classList.add('menu__livello--aperto');
      if (history.state && history.state.drawer === this.id) history.replaceState(this._stato(history.state), '');
      requestAnimationFrame(() => livello.querySelector('[data-chiudi-livello]')?.focus({ preventScroll: true }));
      this._precaricaLivelli(livello);
    }

    chiudiLivello({ senzaFocus = false } = {}) {
      const ultimo = this.livelli.pop();
      if (!ultimo) return;
      const { el, origine } = ultimo;
      const sotto = this.livelli.length ? this.livelli[this.livelli.length - 1].el : this.querySelector('.menu__livello--radice');
      if (sotto) sotto.inert = false;
      origine?.setAttribute('aria-expanded', 'false');
      el.classList.remove('menu__livello--aperto');
      // il livello che esce copre ancora per un attimo quello sotto: inert, così un tocco arriva alla voce del livello sotto, che è
      // già al suo posto (19/10/2026: prima toccando "Donna" subito dopo "‹ Uomo" si apriva la voce di Uomo sulla stessa riga)
      el.inert = true;
      this._uscente = el;
      // si nasconde solo se nel frattempo non è stato riaperto: guardando la classe, un livello chiuso e riaperto subito (prima del
      // doppioFrame che rimette la classe) restava nascosto e il menu si bloccava (difetto trovato il 14/10/2026)
      dopoTransizione(el, 'transform', () => { if (!this.livelli.some((l) => l.el === el)) { el.hidden = true; el.inert = false; if (this._uscente === el) this._uscente = null; } }, 400);
      if (history.state && history.state.drawer === this.id) history.replaceState(this._stato(history.state), '');
      if (!senzaFocus) origine?.focus({ preventScroll: true });
    }

    _azzeraLivelli() {
      this.livelli.forEach(({ el, origine }) => { el.classList.remove('menu__livello--aperto'); el.hidden = true; el.inert = false; origine?.setAttribute('aria-expanded', 'false'); });
      this.livelli = [];
      if (this._uscente) { this._uscente.hidden = true; this._uscente.inert = false; this._uscente = null; }
      const radice = this.querySelector('.menu__livello--radice'); if (radice) radice.inert = false;
      // le card nei livelli remoti tornano chiuse e senza esito
      this.querySelectorAll('[data-piu][aria-expanded="true"]').forEach((b) => MES.apriTaglie(b, false));
      this.querySelectorAll('.card__esito').forEach((p) => { p.hidden = true; });
    }

    _suPopstate(e) {
      if (!this.aperto) return;
      // la voce tolta era di un altro script (es. i filtri di collezione.js): la nostra è di nuovo corrente, il drawer resta
      if (e && e.state && e.state.drawer === this.id) return;
      if (this.livelli.length) {
        // il tasto indietro ha tolto la nostra voce: chiudo il livello e la rimetto, così il prossimo indietro chiude il drawer
        this.chiudiLivello();
        history.pushState(this._stato(), '');
        return;
      }
      this.chiudi({ daHistory: true });
    }

    /* ---- chiusura trascinando verso il basso (solo foglio) ---- */
    _trascinamento() {
      const p = () => this.pannello;   // riletto a ogni evento: il carrello sostituisce il pannello a ogni aggiornamento
      let y0 = null, x0 = 0, dy = 0, attivo = false, deciso = false, inCima = false, ultimoY = 0, ultimoT = 0, velocita = 0, conSoglia = false;
      let tocco = null;   // tolleranza: punto, tempo, comando di partenza, spostamento massimo, scorrimento del livello
      const annulla = () => { y0 = null; if (!attivo) return; attivo = false; this.classList.remove('drawer--trascino'); const el = p(); if (el) el.style.transform = ''; };
      this.addEventListener('touchstart', (e) => {
        if (!this.eFoglio || e.touches.length !== 1 || !p()) { annulla(); return; }   // seconda dita: si torna su
        // in un'area di testo, un menu a tendina o una riga che scorre di lato il dito ha un altro lavoro: niente trascinamento.
        // Un campo a riga singola nella testa (la ricerca) invece si può trascinare in verticale: lì il dito non ha altro da fare,
        // e Chrome "attira" sul campo anche i tocchi partiti sulla maniglia
        const campo = e.target.closest('input, textarea, select, [data-no-trascino]');
        if (campo && !(campo.tagName === 'INPUT' && campo.closest('[data-maniglia]'))) { y0 = null; return; }
        y0 = e.touches[0].clientY; x0 = e.touches[0].clientX; ultimoY = y0; ultimoT = e.timeStamp; dy = 0; velocita = 0; attivo = false; deciso = false;
        // finché il dito resta entro 16 px è ancora un tocco (14/10/2026 sulle voci, entro 10 px). Dal 19/10/2026 vale anche per un
        // dito che parte di poco fuori da una voce (i 16 px ai lati, gli 8 px tra la voce e la freccia: il 31–40 % dell'area di un
        // livello del menu), che Safari dà comunque alla voce più vicina: prima bastava 1 px verso il basso partendo da lì per far
        // partire il trascinamento, che annullava il clic. Dal vuoto vero (maniglia, spazi lontani dai comandi) si trascina subito
        const comando = this._comandoVicino(e.target, x0, y0);
        conSoglia = !!comando;
        // "in cima" si decide qui, prima che lo scroll cambi: dalla maniglia sempre; altrimenti se il livello aperto (o il corpo) ha scrollTop 0
        const scrollante = this.livelli.length ? this.livelli[this.livelli.length - 1].el : (e.target.closest('.menu__livello, .drawer__corpo') || this.querySelector('.drawer__corpo'));
        inCima = !!e.target.closest('[data-maniglia]') || !scrollante || scrollante.scrollTop <= 0;
        tocco = this.id === 'menu-drawer' ? { x: x0, y: y0, t: e.timeStamp, comando, scrollante, scroll: scrollante ? scrollante.scrollTop : 0, max: 0 } : null;
      }, { passive: true });
      this.addEventListener('touchmove', (e) => {
        if (y0 === null) return;
        const y = e.touches[0].clientY, x = e.touches[0].clientX;
        const d = y - y0;
        if (tocco) tocco.max = Math.max(tocco.max, Math.hypot(x - x0, d));
        if (!deciso) {
          const dx = x - x0;
          if (d === 0 && dx === 0) return;   // nessuna direzione ancora
          // su iOS arrivano anche i touchmove di 1–3 px: annullarli si mangiava il click (il menu "andava a vuoto" e serviva un
          // secondo tocco). Sotto i 16 px niente preventDefault: il click arriva. Il trascinamento per chiudere parte subito solo
          // dal vuoto della maniglia; altrove dopo 16 px, se il browser non ha già preso il gesto per lo scorrimento
          if (conSoglia && Math.abs(d) < 16 && Math.abs(dx) < 16) return;
          deciso = true;
          // iOS decide al PRIMO touchmove: se non lo annulliamo subito, lo scroll nativo prende il gesto e i touchmove
          // seguenti arrivano con cancelable = false (il preventDefault dopo non vale più).
          // Un gesto più orizzontale che verticale (riga dei suggeriti nel carrello, tabella larga) non è un trascinamento.
          attivo = d > 0 && Math.abs(dx) <= d && inCima && e.cancelable !== false;
          if (attivo) { this.classList.add('drawer--trascino'); }
        }
        if (!attivo) return;
        if (e.cancelable === false) { annulla(); return; }   // il gesto lo ha già preso il browser (es. tocco durante il rimbalzo)
        e.preventDefault();   // il foglio segue il dito, il contenuto non scorre
        dy = Math.max(0, d);
        p().style.transform = `translateY(${dy}px)`;
        const dt = Math.max(1, e.timeStamp - ultimoT);
        velocita = (y - ultimoY) / dt; ultimoY = y; ultimoT = e.timeStamp;
      }, { passive: false });
      const fine = (e) => {
        if (y0 === null) return;
        y0 = null;
        if (!attivo) { if (e && e.type === 'touchend') this._tolleranza(tocco, e); tocco = null; return; }
        tocco = null;
        attivo = false;
        this.classList.remove('drawer--trascino');
        const el = p(); if (!el) return;
        const soglia = el.offsetHeight * 0.3;
        if (dy > soglia || (velocita > 0.6 && dy > 40)) {   // il "lancio" chiude solo dopo 40 px: 6 px veloci erano un tocco (14/10/2026)
          el.style.transform = 'translateY(100%)';   // continua la corsa verso il basso, poi chiudi() nasconde e azzera lo stile
          this.chiudi();
        } else {
          el.style.transform = '';   // torna su
        }
      };
      this.addEventListener('touchend', fine);
      this.addEventListener('touchcancel', fine);
    }

    /* il comando sotto il dito, o il più vicino entro 16 px (dito partito nei margini, tra voce e freccia, nello spazio sotto
       "‹ Indietro"): nel livello del menu in cima, altrimenti in tutto il pannello */
    _comandoVicino(bersaglio, x, y) {
      const diretto = bersaglio.closest && bersaglio.closest(COMANDI_TOCCO);
      if (diretto && this.contains(diretto)) return diretto;
      const ambito = this.livelli.length ? this.livelli[this.livelli.length - 1].el : this.pannello;
      if (!ambito) return null;
      let migliore = null, distanza = 16.5;
      ambito.querySelectorAll(COMANDI_TOCCO).forEach((c) => {
        const r = c.getBoundingClientRect();
        if (!r.width || !r.height) return;
        const dx = x < r.left ? r.left - x : x > r.right ? x - r.right : 0;
        const dy = y < r.top ? r.top - y : y > r.bottom ? y - r.bottom : 0;
        const dist = Math.hypot(dx, dy);
        if (dist < distanza) { distanza = dist; migliore = c; }
      });
      return migliore;
    }

    /* tolleranza del tocco (19/10/2026, solo menu): su iPhone il clic non parte se il dito scivola di più di circa 10 pt, e un pollice
       che tocca una voce scivola spesso di 10–15 px. Se il dito si è mosso tra 6 e 16 px, in meno di 600 ms, senza far scorrere il
       livello e senza trascinare il foglio, e in 350 ms il browser non ha mandato nessun clic, lo manda il tema sulla voce di
       partenza. Il click vero che arrivasse dopo viene ignorato (ascoltatore di registro in connectedCallback) */
    _tolleranza(tocco, e) {
      if (!tocco || !tocco.comando || tocco.max < 6 || tocco.max > 16 || e.timeStamp - tocco.t > 600) return;
      if (tocco.scrollante && Math.abs(tocco.scrollante.scrollTop - tocco.scroll) > 1) return;
      const finito = performance.now();
      setTimeout(() => {
        if ((this._ultimoClic || 0) >= finito - 30) return;   // il browser ha mandato il suo clic
        if (!this.aperto || !tocco.comando.isConnected || this._salita() > 16) return;
        this._sintetico = { el: tocco.comando, alle: performance.now() };
        tocco.comando.click();
      }, 350);
    }

    _suTasto(e) {
      if (e.key === 'Escape') { e.preventDefault(); this.chiudi(); return; }
      if (e.key !== 'Tab') return;
      const focalizzabili = Array.from(this.pannello.querySelectorAll(FOCUSABILI)).filter((el) => el.offsetParent !== null);
      if (!focalizzabili.length) { e.preventDefault(); return; }
      const primo = focalizzabili[0], ultimo = focalizzabili[focalizzabili.length - 1];
      if (e.shiftKey && (document.activeElement === primo || document.activeElement === this.pannello)) { e.preventDefault(); ultimo.focus(); }
      else if (!e.shiftKey && document.activeElement === ultimo) { e.preventDefault(); primo.focus(); }
    }
  }
  customElements.define('mes-drawer', MesDrawer);
  MES.dopoTransizione = dopoTransizione;
  // "Carrello (n)" nel piede del menu segue il carrello (un solo ascoltatore per tutta la pagina)
  document.addEventListener('mes:carrello-cambiato', (e) => {
    if (!e.detail) return;
    const n = Number(e.detail.item_count) || 0;
    document.querySelectorAll('[data-menu-carrello-n]').forEach((el) => { el.textContent = n; el.classList.toggle('menu__contatore--vuoto', n === 0); });
    // etichetta della borsa nel piede del menu: "Apri il carrello, 2 articoli" (stesse chiavi dell'header)
    document.querySelectorAll('[data-menu-carrello][data-etichetta]').forEach((a) => { const m = (n === 1 ? a.dataset.testoUno : a.dataset.testoAltri) || ''; a.setAttribute('aria-label', a.dataset.etichetta + ', ' + m.replace(/\d+/, n)); });
  });
  // passaggio telefono ↔ computer (rotazione di un tablet a cavallo dei 990 px) con un drawer aperto: si chiude, così foglio e
  // pannello laterale non si mescolano (i filtri su computer sono una colonna, non un drawer)
  DESKTOP.addEventListener('change', () => document.querySelectorAll('.drawer').forEach((d) => { if (d.aperto) d.chiudi({ senzaFocus: true }); }));

  /* ---------------------------------------------------------------- header */
  class MesHeader extends HTMLElement {
    connectedCallback() {
      // --header-visibile: altezza dell'header quando si vede, 0 quando è nascosto; la usano la barra dei filtri delle collezioni e la
      // colonna informazioni della scheda su computer, per fermarsi sotto l'header (06/10/2026)
      const aggiorna = () => { this.style.setProperty('--header-altezza', this.offsetHeight + 'px'); document.documentElement.style.setProperty('--header-visibile', this.classList.contains('header--nascosto') ? '0px' : this.offsetHeight + 'px'); };
      aggiorna(); window.addEventListener('resize', aggiorna, { passive: true });
      if (this.dataset.compatta !== 'true') return;
      let ultimoY = window.scrollY;
      let ticking = false;
      const soglia = this.offsetHeight;
      window.addEventListener('scroll', () => {
        if (ticking) return;
        ticking = true;
        requestAnimationFrame(() => {
          const y = window.scrollY;
          if (document.body.classList.contains('drawer-aperto')) { ticking = false; return; }
          if (y > ultimoY && y > soglia) {
            // un mega menu aperto non resta sospeso in cima quando l'header sparisce (revisione del 06/10/2026)
            if (!this.classList.contains('header--nascosto')) this.dispatchEvent(new CustomEvent('mes:header-nascosto'));
            this.classList.add('header--nascosto');
          } else this.classList.remove('header--nascosto');
          aggiorna();
          ultimoY = y;
          ticking = false;
        });
      }, { passive: true });
    }
  }
  customElements.define('mes-header', MesHeader);

  /* ---------------------------------------------------------------- mega menu (desktop) */
  /* Le voci con sottovoci e la voce Grafiche aprono un pannello sotto l'header: al passaggio
     del mouse, al click sulla freccia, con Tab + Invio. Esc e click fuori chiudono. */
  class MesMega {
    constructor(nav) {
      this.nav = nav;
      this.voci = Array.from(nav.querySelectorAll('[data-mega-voce]'));
      this.desktop = window.matchMedia('(min-width: 990px)');
      this.voci.forEach((voce) => {
        const apri = voce.querySelector('[data-mega-apri]');
        apri?.addEventListener('click', () => this.alterna(voce));
        // solo con un mouse vero (19/10/2026): su iPad in orizzontale il tocco su "Uomo" manda anche mouseenter, il pannello
        // compariva e Safari usava quel tocco per il passaggio, non per aprire il link. Al tocco il pannello si apre dalla freccia
        voce.addEventListener('pointerenter', (e) => { if (e.pointerType === 'mouse' && this.desktop.matches) { clearTimeout(this._t); this.apri(voce); voce.dataset.daHover = '1'; } });
        voce.addEventListener('mouseleave', () => { clearTimeout(this._t); this._t = setTimeout(() => this.chiudi(voce), 150); });
        voce.addEventListener('focusout', (e) => { if (!voce.contains(e.relatedTarget)) this.chiudi(voce); });
      });
      document.addEventListener('keydown', (e) => { if (e.key === 'Escape') this.chiudiTutti(true); });
      document.addEventListener('click', (e) => { if (!nav.contains(e.target)) this.chiudiTutti(); });
      nav.closest('mes-header')?.addEventListener('mes:header-nascosto', () => this.chiudiTutti(false));
    }
    apri(voce) {
      this.voci.forEach((v) => { if (v !== voce) this.chiudi(v); });
      voce.querySelector('[data-mega-pannello]').hidden = false;
      voce.querySelector('[data-mega-apri]')?.setAttribute('aria-expanded', 'true');
      voce.classList.add('header__nav-voce--aperta');
    }
    chiudi(voce) {
      voce.querySelector('[data-mega-pannello]').hidden = true;
      voce.querySelector('[data-mega-apri]')?.setAttribute('aria-expanded', 'false');
      voce.classList.remove('header__nav-voce--aperta');
      delete voce.dataset.daHover;
    }
    alterna(voce) {
      // se il passaggio del mouse l'ha già aperto, il click sulla freccia non lo richiude
      if (voce.querySelector('[data-mega-pannello]').hidden) this.apri(voce);
      else if (voce.dataset.daHover === '1') delete voce.dataset.daHover;
      else this.chiudi(voce);
    }
    chiudiTutti(focalizza) {
      const aperta = this.voci.find((v) => !v.querySelector('[data-mega-pannello]').hidden);
      this.voci.forEach((v) => this.chiudi(v));
      if (aperta && focalizza) aperta.querySelector('[data-mega-apri]')?.focus();
    }
  }

  /* ---------------------------------------------------------------- ricerca predittiva */
  /* <mes-ricerca>: mentre si scrive chiede al server la sezione "ricerca-suggerimenti" via
     /search/suggest (Section Rendering): prodotti, grafiche e collezioni già renderizzati.
     Senza JS resta il form normale verso /search. */
  class MesRicerca extends HTMLElement {
    connectedCallback() {
      // il campo sta nella testa del drawer (30/09/2026), fuori da questo elemento: si cerca nel pannello
      this.campo = this.querySelector('[data-ricerca-campo]') || this.closest('.drawer__pannello')?.querySelector('[data-ricerca-campo]');
      this.esito = this.querySelector('[data-suggerimenti]');
      this.vuoto = this.querySelector('[data-ricerca-vuoto]');   // categorie e più cercate, prima di scrivere (20/10/2026)
      if (!this.campo || !this.esito) return;
      this._mostra(false);
      this.campo.addEventListener('input', () => { clearTimeout(this._t); this._t = setTimeout(() => this.cerca(), 250); });
      this.campo.addEventListener('keydown', (e) => {
        if (e.key === 'ArrowDown') { const primo = this.esito.querySelector('a'); if (primo) { e.preventDefault(); primo.focus(); } }
      });
      this.esito.addEventListener('keydown', (e) => {
        if (e.key !== 'ArrowDown' && e.key !== 'ArrowUp') return;
        const link = Array.from(this.esito.querySelectorAll('a'));
        const i = link.indexOf(document.activeElement);
        if (i < 0) return;
        e.preventDefault();
        if (e.key === 'ArrowUp') (i === 0 ? this.campo : link[i - 1]).focus();
        else link[Math.min(i + 1, link.length - 1)].focus();
      });
      this.closest('mes-drawer')?.addEventListener('mes:drawer-aperto', () => { if (this.campo.value.trim().length >= 2) this.cerca(); });
      // Invio con una richiesta di suggerimenti in volo: si annulla prima di andare alla pagina dei risultati (il pixel di Shopify la segnalava come errore)
      this.campo.form?.addEventListener('submit', () => { clearTimeout(this._t); this._inviato = true; if (this.controller) this.controller.abort(); });
    }

    async cerca() {
      if (this._inviato) return;   // il modulo è già partito verso la pagina dei risultati
      const q = this.campo.value.trim();
      if (this.controller) this.controller.abort();
      if (q.length < 2) { this.svuota(); return; }
      this.controller = new AbortController();
      const url = new URL(this.dataset.url, location.origin);
      url.searchParams.set('q', q);
      url.searchParams.set('section_id', this.dataset.sezione);
      url.searchParams.set('resources[type]', 'product,collection');
      url.searchParams.set('resources[limit]', this.dataset.limite || 5);
      url.searchParams.set('resources[options][unavailable_products]', 'last');
      this.esito.setAttribute('aria-busy', 'true');
      try {
        const html = await (await fetch(url.href, { signal: this.controller.signal })).text();
        const doc = new DOMParser().parseFromString(html, 'text/html');
        const contenuto = doc.querySelector('[data-suggerimenti-contenuto]');
        this.esito.replaceChildren(...(contenuto ? [contenuto] : []));
        this.campo.setAttribute('aria-expanded', String(Boolean(contenuto)));
        this._mostra(Boolean(contenuto));
      } catch (err) {
        if (err.name !== 'AbortError') this.svuota();
      } finally {
        this.esito.setAttribute('aria-busy', 'false');
      }
    }

    svuota() { this.esito.replaceChildren(); this.campo.setAttribute('aria-expanded', 'false'); this._mostra(false); }

    /* scambio tra il blocco "prima di scrivere" e i suggerimenti: con l'opacità e il blocco attenuato fuori dal flusso (classe
       ricerca__blocco--via: opacity .02, pointer-events none, inert), mai display: none; e solo a dito fermo (regola dei tocchi su
       iPhone, 20/10/2026). Lo stato richiesto per ultimo vince anche se arriva in ritardo */
    _mostra(suggerimenti) {
      this._statoVoluto = suggerimenti;
      const applica = () => {
        const sugg = this._statoVoluto;
        const via = (el, si) => { if (!el) return; el.classList.toggle('ricerca__blocco--via', si); if (si) { el.setAttribute('inert', ''); el.setAttribute('aria-hidden', 'true'); } else { el.removeAttribute('inert'); el.removeAttribute('aria-hidden'); } };
        via(this.vuoto, sugg); via(this.esito, !sugg);
      };
      (window.MES && MES.aDitoFermo ? MES.aDitoFermo : (f) => f())(applica);
    }
  }
  customElements.define('mes-ricerca', MesRicerca);

  /* ---------------------------------------------------------------- FAQ */
  /* <mes-faq>: una sola domanda aperta per volta; l'indirizzo segue la domanda aperta (#faq-…)
     così si può linkare; all'arrivo con un #faq-… quella domanda è già aperta. */
  class MesFaq extends HTMLElement {
    connectedCallback() {
      this.voci = Array.from(this.querySelectorAll('[data-faq]'));
      this.voci.forEach((d) => d.addEventListener('toggle', () => {
        if (!d.open) { if (location.hash === '#' + d.id) history.replaceState(null, '', location.pathname + location.search); return; }
        this.voci.forEach((altra) => { if (altra !== d) altra.open = false; });
        history.replaceState(null, '', '#' + d.id);
      }));
      const iniziale = location.hash && this.querySelector(location.hash);
      if (iniziale && iniziale.matches('[data-faq]')) { iniziale.open = true; iniziale.scrollIntoView({ block: 'start' }); }
    }
  }
  customElements.define('mes-faq', MesFaq);

  /* ---------------------------------------------------------------- personaggi */
  /* <mes-personaggio> (DESIGN.md, "Personaggi in gioco"): tre pose pronte nei data-attribute,
     fumetto con battute per contesto, reazione al tocco. reagisci(contesto, posa) è l'unica porta:
     la usano carrello.js (aggiunto, rimosso, aumentato, soglia) e il tocco. Con "riduci movimento"
     niente animazioni e niente coriandoli, ma pose e battute cambiano lo stesso. */
  const attualePosa = (el) => el.dataset.posa;   // RIDOTTO (prefers-reduced-motion) è dichiarato sopra, con il drawer
  class MesPersonaggio extends HTMLElement {
    connectedCallback() {
      this.img = this.querySelector('[data-img]');
      this.fumetto = this.querySelector('[data-fumetto]');
      // niente "sorpresa": l'immagine è invisibile finché non è scaricata, poi entra in dissolvenza
      const pronta = () => this.img.classList.add('personaggio__img--pronta');
      if (this.img.complete && this.img.naturalWidth > 0) pronta(); else this.img.addEventListener('load', pronta, { once: true });
      this.pose = { neutro: this.dataset.neutro, festa: this.dataset.festa, attesa: this.dataset.attesa };
      const lista = (t) => (t || '').split('|').map((x) => x.trim()).filter(Boolean);
      this.battute = lista(this.dataset.battute);
      this.tocchi = lista(this.dataset.tocco);
      // liste per evento (solo nel carrello): data-battute-aggiunto, -rimosso, -aumentato, -soglia
      this.liste = {};
      ['aggiunto', 'rimosso', 'aumentato', 'soglia'].forEach((k) => { const v = this.dataset['battute' + k[0].toUpperCase() + k.slice(1)]; if (v) this.liste[k] = lista(v); });
      this._ultima = -1;
      this.querySelector('[data-tocca]')?.addEventListener('click', () => this.reagisci('tocco'));
      // Peso: l'immagine è lazy (nel drawer chiuso non si scarica niente). Le altre due pose si
      // scaricano solo quando il personaggio è davvero visibile, così lo scambio poi è istantaneo.
      this._precaricato = false;
      const precarica = () => {
        if (this._precaricato) return; this._precaricato = true;
        const via = () => Object.values(this.pose).forEach((u) => { if (u && u !== this.img.currentSrc) { const i = new Image(); i.src = u; } });
        if (window.requestIdleCallback) requestIdleCallback(via, { timeout: 1500 }); else setTimeout(via, 300);
      };
      const subito = this.hasAttribute('data-subito');
      const visibile = () => { if (!this.isConnected) return; precarica(); if (subito) this.parla(this.battute); };   // il drawer ricrea il contenuto: gli elementi vecchi non devono più scaricare niente
      // Dentro un drawer: a ogni apertura (il drawer nasce nascosto e il contenuto viene ricreato);
      // altrove (404, ricerca): appena entra nello schermo.
      const drawer = this.closest('.drawer');   // mes-drawer o mes-carrello
      if (drawer) {
        drawer.addEventListener('mes:drawer-aperto', visibile);
        if (drawer.aperto) setTimeout(visibile, 250);
      } else if ('IntersectionObserver' in window) {
        new IntersectionObserver((voci, o) => { if (voci.some((v) => v.isIntersecting)) { visibile(); o.disconnect(); } }, { threshold: .3 }).observe(this);
      } else visibile();
    }

    /* cambia posa e dice una battuta. posa facoltativa: per il tocco ne sceglie una diversa da quella attuale */
    reagisci(contesto, posa) {
      const attuale = this.dataset.posa;
      if (!posa) { const altre = Object.keys(this.pose).filter((k) => k !== attuale && this.pose[k]); posa = altre[Math.floor(Math.random() * altre.length)] || attuale; }
      this.posa(posa);
      this.parla(contesto === 'tocco' ? this.tocchi : (this.liste[contesto] || this.battute));
      if (!RIDOTTO.matches) {
        this.classList.remove('personaggio--salta'); void this.offsetWidth; this.classList.add('personaggio--salta');
        if (contesto === 'soglia') this.coriandoli();
      }
    }

    posa(nome) {
      const u = this.pose[nome];
      if (!u || nome === this.dataset.posa) return;
      this.img.removeAttribute('srcset'); this.img.src = u;   // già precaricata: scambio istantaneo
      // cambio solo la classe della posa: "pronta" resta, altrimenti l'immagine torna invisibile
      this.img.classList.remove('personaggio__img--' + attualePosa(this)); this.img.classList.add('personaggio__img--' + nome);
      this.dataset.posa = nome;
    }

    parla(lista) {
      if (!this.fumetto || !lista.length) return;
      let i = Math.floor(Math.random() * lista.length);
      if (lista.length > 1 && i === this._ultima) i = (i + 1) % lista.length;
      this._ultima = i;
      this.fumetto.textContent = lista[i];
      this.fumetto.hidden = false;
      this.fumetto.classList.remove('personaggio__fumetto--via'); void this.fumetto.offsetWidth; this.fumetto.classList.add('personaggio__fumetto--via');
      clearTimeout(this._t);
      this._t = setTimeout(() => { this.fumetto.hidden = true; }, 3500);
    }

    /* coriandoli in CSS: 24 pezzetti, colori dai token, spariscono da soli */
    coriandoli() {
      const box = document.createElement('span');
      box.className = 'coriandoli'; box.setAttribute('aria-hidden', 'true');
      for (let k = 0; k < 24; k++) {
        const c = document.createElement('i');
        c.style.setProperty('--x', (Math.random() * 100).toFixed(0) + '%');
        c.style.setProperty('--r', (Math.random() * 360).toFixed(0) + 'deg');
        c.style.setProperty('--d', (Math.random() * .6).toFixed(2) + 's');
        c.style.setProperty('--s', (6 + Math.random() * 6).toFixed(0) + 'px');
        c.dataset.c = k % 4;
        box.appendChild(c);
      }
      this.appendChild(box);
      setTimeout(() => box.remove(), 2600);
    }
  }
  customElements.define('mes-personaggio', MesPersonaggio);

  /* ---------------------------------------------------------------- annunci */
  /* Nastro continuo: il gruppo di messaggi viene misurato e ripetuto finché copre almeno due volte la
     finestra; la durata del ciclo è (larghezza del gruppo / velocità in px/s), quindi la velocità è la
     stessa su ogni schermo; l'animazione sposta il nastro di esattamente un gruppo e riparte: nessun
     salto. Con "riduci movimento": fermo, un messaggio alla volta (intervallo dalle impostazioni). */
  class MesAnnunci extends HTMLElement {
    connectedCallback() {
      this.finestra = this.querySelector('[data-finestra]');
      this.nastro = this.querySelector('[data-nastro]');
      this.gruppo = this.querySelector('[data-gruppo]');
      if (!this.nastro || !this.gruppo) return;
      this.velocita = Math.max(10, parseInt(this.dataset.velocita, 10) || 50);
      this.intervallo = parseInt(this.dataset.intervallo, 10) || 5000;
      this._fermo = this._fermo.bind(this); this._scorri = this._scorri.bind(this);
      if (riduciMovimento.matches) this._fermo(); else this._scorri();
      // il carattere web può arrivare dopo e cambiare la larghezza del gruppo: rimisuro, così il ciclo si richiude senza salti
      if (document.fonts && document.fonts.ready) document.fonts.ready.then(() => { if (!riduciMovimento.matches) this._scorri(); });
      riduciMovimento.addEventListener('change', () => (riduciMovimento.matches ? this._fermo() : this._scorri()));
      // un tocco sul nastro lo ferma (pausa silenziosa), un altro lo riavvia
      this.addEventListener('click', (e) => { if (!e.target.closest('a') && !riduciMovimento.matches) this.nastro.style.animationPlayState = this.nastro.style.animationPlayState === 'paused' ? 'running' : 'paused'; });
      let t; window.addEventListener('resize', () => { clearTimeout(t); t = setTimeout(() => { if (!riduciMovimento.matches) this._scorri(); }, 200); }, { passive: true });
      // messaggio programmato (23/10/2026): se la pagina resta aperta oltre la fine, all'ora di fine sparisce anche dalle copie del nastro
      const prog = this.gruppo.querySelector('[data-annuncio-al]');
      const resta = prog ? Number(prog.getAttribute('data-annuncio-al')) - Date.now() : 0;
      if (prog && resta > 0 && resta < 2147483647) setTimeout(() => { this.querySelectorAll('[data-annuncio-al]').forEach((x) => x.remove()); if (riduciMovimento.matches) this._fermo(); else this._scorri(); }, resta);
    }

    _scorri() {
      clearInterval(this.timer);
      this.classList.remove('annunci--fermo');
      this.querySelectorAll('.annunci__messaggio').forEach((m) => { m.hidden = false; m.classList.remove('annunci__messaggio--corrente'); m.removeAttribute('aria-hidden'); });
      this.querySelectorAll('.annunci__gruppo--copia').forEach((c) => c.remove());
      const larghezzaGruppo = this.gruppo.getBoundingClientRect().width;
      const larghezzaFinestra = this.finestra.getBoundingClientRect().width;
      if (!larghezzaGruppo || !larghezzaFinestra) return;
      // copie: abbastanza da coprire la finestra più un gruppo intero (quello che esce a sinistra)
      const copie = Math.max(1, Math.ceil(larghezzaFinestra / larghezzaGruppo));
      for (let k = 0; k < copie; k++) {
        const c = this.gruppo.cloneNode(true); c.classList.add('annunci__gruppo--copia'); c.setAttribute('aria-hidden', 'true'); c.removeAttribute('data-gruppo');
        c.querySelectorAll('a').forEach((a) => a.setAttribute('tabindex', '-1'));
        this.nastro.appendChild(c);
      }
      this.nastro.style.setProperty('--annunci-gruppo', larghezzaGruppo + 'px');
      this.nastro.style.setProperty('--annunci-durata', (larghezzaGruppo / this.velocita).toFixed(2) + 's');
      this.nastro.style.animationPlayState = 'running';
      this.nastro.classList.add('annunci__nastro--scorre');
    }

    _fermo() {
      this.nastro.classList.remove('annunci__nastro--scorre');
      this.querySelectorAll('.annunci__gruppo--copia').forEach((c) => c.remove());
      this.classList.add('annunci--fermo');
      // a rotazione con l'opacità, non con hidden (revisione del 20/10/2026): un messaggio che compare da display: none ogni 5 s è lo stesso
      // meccanismo dei tocchi persi su iPhone (Safari scambia la comparsa per un passaggio del mouse). I messaggi stanno tutti nella
      // stessa cella (base.css) e il corrente è l'unico opaco e toccabile; gli altri sono nascosti ai lettori di schermo
      const m = Array.from(this.gruppo.querySelectorAll('.annunci__messaggio'));
      const mostra = (k) => m.forEach((x, i) => { x.classList.toggle('annunci__messaggio--corrente', i === k); x.setAttribute('aria-hidden', i === k ? 'false' : 'true'); });
      mostra(0);
      clearInterval(this.timer);
      if (m.length > 1) { let i = 0; this.timer = setInterval(() => { i = (i + 1) % m.length; mostra(i); }, this.intervallo); }
    }
  }
  customElements.define('mes-annunci', MesAnnunci);

  /* ---------------------------------------------------------------- comportamenti sparsi */
  document.addEventListener('DOMContentLoaded', () => {
    // policy (22/10/2026): un solo <h1>. Il titolo lo stampa la sezione policy-testa; quello che Shopify mette nel contenuto (.shopify-policy__title)
    // era già nascosto dal CSS ma restava nel codice come secondo <h1>: si toglie (senza JavaScript resta solo nascosto). Il testo non si tocca
    if (document.querySelector('.policy-testa__titolo')) document.querySelectorAll('.shopify-policy__title').forEach((t) => t.remove());
    // striscia della soglia sotto l'header: solo senza barra annunci e con righe da spedire (lo stato lo ha scritto il Liquid nella classe)
    const striscia = document.querySelector('[data-soglia-striscia]');
    if (striscia && !document.querySelector('mes-annunci')) { const s = striscia.querySelector('[data-soglia]'); striscia.hidden = !s || s.classList.contains('soglia--vuota'); }
    // selettori lingua e paese: invio al cambio
    document.querySelectorAll('select[data-invia-al-cambio]').forEach((s) => s.addEventListener('change', () => s.form?.submit()));

    // mega menu desktop
    document.querySelectorAll('[data-mega]').forEach((nav) => new MesMega(nav));

    // personaggi: in scheda prodotto precarico, nei tempi morti, la posa che entrerebbe nel drawer
    const pre = document.querySelector('[data-personaggio-prefetch]');
    if (pre) {
      const via = () => pre.dataset.personaggioPrefetch.split(',').forEach((u) => { if (u) { const i = new Image(); i.fetchPriority = 'low'; i.src = u; } });
      if (window.requestIdleCallback) requestIdleCallback(via, { timeout: 2000 }); else setTimeout(via, 800);
    }

    // footer: gruppi aperti su desktop, chiusi su mobile
    const desktop = window.matchMedia('(min-width: 990px)');
    const gruppiFooter = document.querySelectorAll('.footer__gruppo');
    const sistemaFooter = () => gruppiFooter.forEach((d) => { d.open = desktop.matches; });
    sistemaFooter();
    desktop.addEventListener('change', sistemaFooter);

    // home: tab della collezione in evidenza (cambio senza ricaricare)
    document.querySelectorAll('[data-tab]').forEach((sez) => {
      const voci = sez.querySelectorAll('[data-tab-voce]'), pannelli = sez.querySelectorAll('[data-tab-pannello]');
      /* i tab oltre il primo arrivano al tocco (sezione griglia-in-evidenza): una richiesta sola per tab, poi resta */
      const carica = async (p) => {
        if (!p.dataset.url || p.dataset.caricato) return;
        p.dataset.caricato = 'in corso';
        p.setAttribute('aria-busy', 'true');
        try {
          const html = await MES.testo(p.dataset.url);
          const doc = new DOMParser().parseFromString(html, 'text/html');
          const griglia = doc.querySelector('.griglia'), piede = doc.querySelector('.sezione__piede');
          if (!griglia) throw new Error('vuota');
          const n = Number(p.dataset.perTab || 6);
          Array.from(griglia.children).slice(n).forEach((li) => li.remove());
          p.querySelector('[data-tab-attesa]')?.remove();
          p.append(griglia); if (piede) p.append(piede);
          p.dataset.caricato = 'sì';
        } catch (e) { delete p.dataset.caricato; /* resta il link "Vedi tutto" */ }
        finally { p.removeAttribute('aria-busy'); }
      };
      voci.forEach((v, i) => v.addEventListener('click', () => {
        voci.forEach((x, k) => { x.classList.toggle('tab__voce--attiva', k === i); x.setAttribute('aria-selected', String(k === i)); });
        pannelli.forEach((p, k) => { p.hidden = k !== i; });
        carica(pannelli[i]);
      }));
    });

  });
})();

/* ---- pressione che resta (24/09/2026): la voce toccata o cliccata resta attenuata finché la pagina non cambia (classe "andando", vedi base.css "tocco e clic").
   Solo i link interni che portano a una pagina e i pulsanti che inviano un modulo: chi apre un drawer o un accordion torna pieno da solo. ---- */
(function () {
  /* barra di caricamento (19/10/2026): appena un tocco porta a un'altra pagina, una riga scura in cima allo schermo avanza finché la
     pagina nuova non arriva. Prima l'unica risposta era la voce attenuata: su una rete lenta, nel menu, sembrava che il tocco non
     fosse andato e si toccava di nuovo. Il foglio del menu resta aperto e la cronologia non si tocca */
  var barra = null;
  var caricamento = {
    mostra: function () {
      if (!barra) { barra = document.createElement('div'); barra.className = 'caricamento-pagina'; barra.setAttribute('aria-hidden', 'true'); document.body.appendChild(barra); }
      barra.hidden = false; barra.classList.remove('caricamento-pagina--via'); void barra.offsetWidth; barra.classList.add('caricamento-pagina--via');
    },
    nascondi: function () { if (barra) { barra.hidden = true; barra.classList.remove('caricamento-pagina--via'); } }
  };
  if (window.MES) window.MES.caricamento = caricamento;
  function parte(nodo, pagina) {
    if (nodo) nodo.classList.add('andando');
    if (!pagina) return;
    if (window.MES) window.MES.inPartenza = performance.now();   // il drawer non fa history.back() mentre la pagina parte (base.js, chiudi)
    caricamento.mostra();
  }
  document.addEventListener('click', function (e) {
    if (e.defaultPrevented || e.button !== 0 || e.metaKey || e.ctrlKey || e.shiftKey || e.altKey) return;
    var a = e.target.closest('a[href]'); if (!a) return;
    var href = a.getAttribute('href');
    if (!href || href.charAt(0) === '#' || /^(mailto|tel|javascript):/i.test(href)) return;
    if (a.target === '_blank' || a.hasAttribute('download') || a.origin !== location.origin) return;
    if (a.pathname === location.pathname && a.search === location.search && a.hash) return;
    parte(a, a.pathname + a.search);
  });
  /* newsletter del footer (20/10/2026): iscrizione diretta alla lista Klaviyo con l'API client (chiave pubblica), stessa lista e stesso flusso
     del popup. Non dipende dal consenso ai cookie: l'invio del modulo è il consenso alla newsletter; la richiesta non manda né scrive
     cookie (credentials omit) e non carica klaviyo.js. Esito e errore sono già nella pagina e compaiono con l'opacità; in caso di errore
     il modulo resta usabile. Senza lista o senza JavaScript parte il modulo cliente di Shopify. */
  /* dal 20/10/2026 sera il footer non ha più il modulo cliente di Shopify (portava l'hCaptcha su ogni pagina): si parte dal submit del
     modulo (Invio o pulsante); senza lista o senza fetch il modulo non manda niente */
  document.addEventListener('submit', function (e) {
    var f = e.target; if (!f || !f.matches || !f.matches('[data-newsletter]')) return;
    e.preventDefault();
    var lista = f.dataset.klaviyoLista, id = f.dataset.klaviyoId, email = f.querySelector('input[type="email"]');
    if (!lista || !id || !email || !window.fetch) return;
    if (!f.reportValidity()) return;
    if (f.dataset.inCorso) return;
    var bottone = f.querySelector('[data-newsletter-invia]'), esito = f.querySelector('[data-newsletter-esito]'), errore = f.querySelector('[data-newsletter-errore]');
    var mostra = function (el, si) { if (!el) return; el.classList.toggle('newsletter__messaggio--via', !si); if (si) { el.removeAttribute('inert'); el.removeAttribute('aria-hidden'); } else { el.setAttribute('inert', ''); el.setAttribute('aria-hidden', 'true'); } };
    mostra(errore, false);
    f.dataset.inCorso = '1'; if (bottone) { bottone.setAttribute('aria-busy', 'true'); bottone.disabled = true; }
    var corpo = { data: { type: 'subscription', attributes: { custom_source: 'Footer del sito', profile: { data: { type: 'profile', attributes: { email: email.value.trim(), subscriptions: { email: { marketing: { consent: 'SUBSCRIBED' } } } } } } }, relationships: { list: { data: { type: 'list', id: lista } } } } };
    fetch('https://a.klaviyo.com/client/subscriptions/?company_id=' + encodeURIComponent(id), { method: 'POST', credentials: 'omit', headers: { 'Content-Type': 'application/vnd.api+json', 'revision': '2025-07-15' }, body: JSON.stringify(corpo) })
      .then(function (r) { if (!r.ok) throw new Error('HTTP ' + r.status); f.classList.add('newsletter--inviata'); mostra(esito, true); f.dataset.esito = 'ok'; })
      .catch(function (err) { mostra(errore, true); })
      .finally(function () { delete f.dataset.inCorso; if (bottone) { bottone.removeAttribute('aria-busy'); bottone.disabled = false; } });
  });
  document.addEventListener('submit', function (e) {
    if (e.defaultPrevented || e.target.target === '_blank') return;
    parte(e.submitter && e.submitter.tagName === 'BUTTON' ? e.submitter : null, e.target.getAttribute('action') || location.pathname);
  });
  // immagini lazy dentro un accordion: all'apertura si caricano subito (07/10/2026: il disegno della guida taglie restava un riquadro vuoto)
  document.addEventListener('toggle', function (e) {
    var d = e.target;
    if (d.tagName !== 'DETAILS' || !d.open) return;
    d.querySelectorAll('img[loading="lazy"]').forEach(function (i) { i.loading = 'eager'; });
  }, true);
  /* "Salta al contenuto" (20/10/2026): il main prende tabindex="-1" solo al momento del salto e lo perde quando il fuoco se ne va. Con il
     tabindex fisso, su iPhone ogni tocco su un link dentro main dava il fuoco a main (il tocco non lo dà al link ma al contenitore
     focalizzabile più vicino); Safari lo salvava con la pagina e, tornando indietro dalla memoria, lo rimetteva portando l'inizio di main
     in cima allo schermo: la pagina ripartiva dall'alto. Causa e prove in dati/ritorno-2026-10-20/ */
  document.addEventListener('click', function (e) {
    var a = e.target.closest && e.target.closest('.salta-al-contenuto'); if (!a) return;
    var m = document.getElementById('contenuto'); if (!m) return;
    m.setAttribute('tabindex', '-1');
    m.addEventListener('blur', function () { m.removeAttribute('tabindex'); }, { once: true });
    m.focus();
  });
  // tornando indietro dalla cache del browser la pagina riappare com'era: si pulisce
  window.addEventListener('pageshow', function (e) {
    if (e.persisted) {
      document.querySelectorAll('.andando').forEach(function (n) { n.classList.remove('andando'); });
      caricamento.nascondi();
      if (window.MES) window.MES.inPartenza = 0;
    }
    // tornando su questa pagina con in cima la voce di un drawer (voce finale del menu → pagina nuova → indietro): la si toglie,
    // così non resta una pressione morta. Al ritorno MAI history.back() (20/10/2026; fino al 19/10 lo faceva chiudi() se il drawer era
    // ancora aperto, cioè con la pagina tornata dalla cache, e prima ancora anche a pagina ricaricata): una navigazione fatta partire
    // mentre si tocca già è proprio un tocco perso. Il drawer si chiude senza toccare la cronologia e la voce si ripulisce con
    // replaceState: resta una voce doppia della stessa pagina, che è il male minore
    var s = history.state;
    if (!s || !s.drawer) return;
    var d = document.getElementById(s.drawer);
    if (!d) return;
    var eraAperto = !!d.aperto;
    // pannello aperto dalla pagina stessa, prima del load, da un tocco tenuto da parte (theme.liquid, 20/10/2026): non è un ritorno,
    // resta aperto (senza questo, la ricerca toccata prima degli script si apriva e si richiudeva subito)
    if (!e.persisted && eraAperto && d.dataset.apertoDaTocco) { delete d.dataset.apertoDaTocco; return; }
    // il MENU si ritrova com'era (20/10/2026, richiesta dell'utente: voce del menu → pagina → indietro → menu aperto allo stesso livello):
    // dalla memoria è ancora aperto e non si tocca, a pagina ricaricata si riapre dalla voce di cronologia (percorso dei livelli).
    // La cronologia resta coerente: indietro chiude il livello, poi il menu, poi torna alla pagina di prima
    if (s.drawer === 'menu-drawer' && typeof d.ripristina === 'function') {
      if (!eraAperto) (window.MES && MES.aDitoFermo ? MES.aDitoFermo : (f) => f())(() => d.ripristina(s));   // non mentre un dito è sulla pagina (comparsa automatica)
      return;
    }
    // gli altri drawer (carrello, filtri, ricerca, guida taglie) si chiudono: il loro contenuto può essere vecchio
    if (eraAperto) d.chiudi({ senzaFocus: true, senzaHistory: true });
    history.replaceState({}, '', location.href);
  });
})();
